// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 4.5L6 7.5L9 4.5\" stroke=\"%23666\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --qe-bg-surface: #f5f7fb;
  --qe-bg-panel: #ffffff;
  --qe-border: #d9dde7;
  --qe-border-strong: #b0b6c4;
  --qe-text-primary: #1f2430;
  --qe-text-secondary: #4a5260;
  --qe-text-muted: #6f7787;
  --qe-text: #1f2430;
  --qe-accent: #2563eb;
  --qe-accent-hover: #1d4ed8;
  --qe-accent-muted: #e1e9ff;
  --qe-bg-muted: #eef2ff;
  --qe-success: #16a34a;
  --qe-warning: #efaa2d;
  --qe-error: #dc2626;
  --qe-panel-width-left: 260px;
  --qe-panel-width-right: 340px;
  --qe-toolbar-height: 52px;
  --qe-header-height: 60px;
  --qe-radius-base: 12px;
}

html,
body,
#root {
  height: 100%;
}

body {
  margin: 0;
  background-color: var(--qe-bg-surface);
  color: var(--qe-text-primary);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
}

button,
input,
select,
textarea {
  font-family: inherit;
}

.qe-app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.qe-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  height: var(--qe-header-height);
  background-color: var(--qe-bg-panel);
  border-bottom: 1px solid var(--qe-border);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  position: sticky;
  top: 0;
  z-index: 10;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 20px;
}

.qe-header__title {
  font-size: 20px;
  font-weight: 600;
  white-space: nowrap;
}

.qe-header__actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
}

.qe-header__separator {
  width: 1px;
  height: 32px;
  background-color: var(--qe-border);
  margin: 0 8px;
}

.qe-header__toggles {
  display: flex;
  gap: 8px;
}

.qe-body {
  flex: 1 1;
  display: flex;
  overflow: hidden;
  min-height: 0;
}

.qe-rail {
  display: flex;
  flex-direction: column;
  background-color: var(--qe-bg-panel);
  overflow: hidden;
}

.qe-rail--left {
  width: var(--qe-panel-width-left);
  border-right: 1px solid var(--qe-border);
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.qe-rail--right {
  width: var(--qe-panel-width-right);
  border-left: 1px solid var(--qe-border);
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.qe-stage {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background-color: var(--qe-bg-surface);
}

.qe-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 16px;
  height: var(--qe-toolbar-height);
  background-color: rgba(255, 255, 255, 0.88);
  border-bottom: 1px solid var(--qe-border);
  backdrop-filter: blur(8px);
  position: sticky;
  top: 0;
  z-index: 5;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 0;
}

.qe-toolbar::-webkit-scrollbar {
  height: 6px;
}

.qe-toolbar::-webkit-scrollbar-track {
  background: transparent;
}

.qe-toolbar::-webkit-scrollbar-thumb {
  background: var(--qe-border);
  border-radius: 3px;
}

.qe-toolbar::-webkit-scrollbar-thumb:hover {
  background: var(--qe-border-strong);
}

.qe-toolbar__group {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 12px;
  border-right: 1px solid var(--qe-border);
  height: 100%;
}

.qe-toolbar__group:first-child {
  padding-left: 0;
}

.qe-toolbar__group:last-child {
  border-right: none;
  padding-right: 0;
}

.qe-toolbar__label {
  font-size: 13px;
  font-weight: 500;
  color: var(--qe-text-muted);
  white-space: nowrap;
}

.qe-toolbar__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid var(--qe-border);
  border-radius: 6px;
  background: white;
  color: var(--qe-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.qe-toolbar__button:hover {
  background: var(--qe-bg-muted);
  border-color: var(--qe-border-strong);
  color: var(--qe-text-primary);
}

.qe-toolbar__button:active {
  transform: scale(0.95);
}

.qe-toolbar__button--symbol {
  min-width: 36px;
  width: auto;
  padding: 0 10px;
  font-weight: 600;
}

.qe-toolbar__button--primary {
  background: var(--qe-accent);
  color: white;
  border-color: var(--qe-accent);
  padding: 0 16px;
  width: auto;
  height: 34px;
  font-size: 12px;
  font-weight: 600;
}

.qe-toolbar__button--primary:hover {
  background: var(--qe-accent-hover);
  border-color: var(--qe-accent-hover);
  color: white;
}

.qe-toolbar__button--active {
  background: var(--qe-accent);
  color: white;
  border-color: var(--qe-accent);
}

.qe-toolbar__button--active:hover {
  background: var(--qe-accent-hover);
  border-color: var(--qe-accent-hover);
}

.qe-toolbar__button--text {
  min-width: 50px;
  width: auto;
  padding: 0 8px;
}

.qe-toolbar__button--tiny {
  width: 20px;
  height: 20px;
  min-width: 20px;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  border-radius: 4px;
}

.qe-toolbar__guide-preset {
  display: inline-flex;
  align-items: center;
  min-width: 138px;
  margin-left: 4px;
}

.qe-toolbar__guide-preset .qe-input {
  height: 32px;
  min-width: 138px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.qe-toolbar__shortcut {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex-shrink: 0;
  min-width: 80px;
  padding-left: 12px;
  margin-left: 12px;
  border-left: 1px solid var(--qe-border);
}

.qe-toolbar__shortcut-label {
  font-size: 10px;
  line-height: 1.2;
  color: var(--qe-text-muted);
  letter-spacing: 0.01em;
  text-align: left;
  max-width: 120px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.qe-toolbar__segment-group {
  display: inline-flex;
  align-items: center;
  padding: 2px 4px;
  border: 1px solid var(--qe-border);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.88);
  gap: 2px;
}

.qe-toolbar__segment {
  border: none;
  background: transparent;
  color: var(--qe-text-secondary);
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.qe-toolbar__segment:hover {
  background-color: var(--qe-bg-muted);
  color: var(--qe-text-primary);
}

.qe-toolbar__segment--active {
  background-color: var(--qe-accent);
  color: #fff;
}

.qe-toolbar__segment--active:hover {
  background-color: var(--qe-accent-hover);
}

.qe-toolbar__segment:focus-visible {
  outline: 2px solid var(--qe-accent);
  outline-offset: 1px;
}

.qe-toolbar__shortcut .qe-input,
.qe-toolbar__shortcut .qe-toolbar__slider,
.qe-toolbar__shortcut .qe-toolbar__toggle-input {
  align-self: stretch;
}

.qe-toolbar__shortcut:first-of-type {
  border-left: none;
  padding-left: 0;
  margin-left: 0;
}

.qe-input--readonly {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 8px 12px;
  border: 1px dashed var(--qe-border);
  border-radius: 8px;
  background-color: #f8fafc;
  color: var(--qe-text-secondary);
  font-size: 13px;
}

.qe-toolbar__shortcut .qe-input.qe-input--color {
  padding: 0;
  width: 32px;
  height: 32px;
}

.qe-toolbar__toggle-input:focus-visible,
.qe-toolbar__slider:focus-visible,
.qe-input--small:focus-visible {
  outline: 2px solid var(--qe-accent);
  outline-offset: 2px;
}

.qe-toolbar__toggle-input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.qe-toolbar__slider {
  width: 100px;
  cursor: pointer;
}

.qe-input--small {
  height: 28px;
  font-size: 12px;
  padding: 4px 8px;
  width: 70px;
  border-radius: 4px;
}

.qe-input--small[type="number"] {
  appearance: textfield;
}

.qe-input--small[type="number"]::-webkit-inner-spin-button,
.qe-input--small[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

select.qe-input--small {
  width: auto;
  min-width: 120px;
  max-width: 180px;
  padding: 4px 28px 4px 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  cursor: pointer;
  appearance: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Question settings bar (inline metadata entry, below the toolbar) */
.qe-qsbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px 16px;
  background-color: rgba(248, 250, 252, 0.96);
  border-bottom: 1px solid var(--qe-border);
  position: sticky;
  top: var(--qe-toolbar-height);
  z-index: 4;
}

.qe-qsbar__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px 14px;
}

.qe-qsbar__field {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.qe-qsbar__label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--qe-text-muted);
  white-space: nowrap;
}

.qe-qsbar__readonly {
  display: flex;
  align-items: center;
  min-width: 120px;
  max-width: 180px;
  height: 28px;
  min-height: 28px;
  padding: 4px 8px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qe-qsbar__field--difficulty {
  min-width: 150px;
}

.qe-qsbar__slider {
  width: 100%;
  min-width: 130px;
  cursor: pointer;
}

.qe-qsbar__field--url {
  flex: 0 1 190px;
  min-width: 170px;
  max-width: 210px;
}

.qe-qsbar__field--time .qe-input--small {
  width: 80px;
}

.qe-qsbar__url-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.qe-qsbar__url-row .qe-input--small[type="url"] {
  flex: 1 1;
  width: auto;
  min-width: 0;
}

.qe-qsbar__mini-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--qe-border);
  border-radius: 4px;
  background: white;
  color: var(--qe-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.qe-qsbar__mini-button:hover:not(:disabled) {
  border-color: var(--qe-border-strong);
  color: var(--qe-text-primary);
}

.qe-qsbar__mini-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Toggles: single horizontal row so the bar stays short */
.qe-qsbar__toggles {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  align-self: stretch;
  padding-bottom: 4px;
}

.qe-qsbar__toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--qe-text-secondary);
  white-space: nowrap;
  cursor: pointer;
}

.qe-qsbar__toggle input {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

select.qe-input--small:hover {
  border-color: var(--qe-border-strong);
}

select.qe-input--small:focus {
  outline: 2px solid var(--qe-accent);
  outline-offset: -1px;
}

.qe-input--color.qe-input--small {
  width: 32px;
  height: 32px;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
}

.qe-toolbar__toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.qe-toolbar__toggle input[type="checkbox"] {
  cursor: pointer;
}

.qe-toolbar__toggle span {
  font-size: 11px;
  color: var(--qe-text-secondary);
  white-space: nowrap;
}

.qe-toolbar__separator {
  width: 1px;
  height: 24px;
  background: var(--qe-border);
  margin: 0 4px;
}

/* Shortcutable Control */
.qe-form__label-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.qe-shortcutable-control__pin {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--qe-text-muted);
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  opacity: 0.3;
}

.qe-shortcutable-control__pin:hover {
  opacity: 0.7;
}

.qe-shortcutable-control__pin--active {
  color: var(--qe-accent);
  opacity: 1;
}

.qe-shortcutable-control__pin--active:hover {
  opacity: 0.8;
}

.qe-shortcutable-control__fallback {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.qe-canvas-shell {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: auto;
}

.qe-canvas-shell--media-drop {
  background-color: rgba(37, 99, 235, 0.06);
  box-shadow: inset 0 0 0 2px var(--qe-accent);
}

.qe-canvas {
  position: relative;
  display: inline-block;
  background-color: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.qe-canvas-ruler {
  position: absolute;
  z-index: 10030;
  border: 1px solid var(--qe-border);
  background-color: rgba(255, 255, 255, 0.94);
  color: var(--qe-text-muted);
  padding: 0;
  font: inherit;
  cursor: crosshair;
  overflow: hidden;
}

.qe-canvas-ruler--horizontal {
  top: -24px;
  left: 0;
  width: 100%;
  height: 24px;
  background-image:
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 9px,
      rgba(71, 85, 105, 0.42) 9px,
      rgba(71, 85, 105, 0.42) 10px
    ),
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 49px,
      rgba(37, 99, 235, 0.46) 49px,
      rgba(37, 99, 235, 0.46) 50px
    );
}

.qe-canvas-ruler--vertical {
  top: 0;
  left: -24px;
  width: 24px;
  height: 100%;
  background-image:
    repeating-linear-gradient(
      0deg,
      transparent 0,
      transparent 9px,
      rgba(71, 85, 105, 0.42) 9px,
      rgba(71, 85, 105, 0.42) 10px
    ),
    repeating-linear-gradient(
      0deg,
      transparent 0,
      transparent 49px,
      rgba(37, 99, 235, 0.46) 49px,
      rgba(37, 99, 235, 0.46) 50px
    );
}

.qe-canvas-ruler__corner {
  position: absolute;
  top: -24px;
  left: -24px;
  z-index: 10031;
  width: 24px;
  height: 24px;
  border: 1px solid var(--qe-border);
  background-color: rgba(255, 255, 255, 0.96);
}

.qe-canvas-ruler__label {
  position: absolute;
  top: 3px;
  color: #475569;
  font-size: 9px;
  line-height: 1;
  letter-spacing: 0;
  pointer-events: none;
}

.qe-canvas-ruler--horizontal .qe-canvas-ruler__label {
  transform: translateX(3px);
}

.qe-canvas-ruler--vertical .qe-canvas-ruler__label {
  left: 3px;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
}

.qe-canvas-guide {
  position: absolute;
  z-index: 10020;
  border: 0;
  touch-action: none;
}

.qe-canvas-guide::after {
  content: "";
  position: absolute;
  background-color: #db2777;
  box-shadow: 0 0 0 1px rgba(219, 39, 119, 0.16);
}

.qe-canvas-guide--vertical {
  top: 0;
  bottom: 0;
  width: 9px;
  margin-left: -4px;
  cursor: ew-resize;
}

.qe-canvas-guide--vertical::after {
  top: 0;
  bottom: 0;
  left: 4px;
  width: 1px;
}

.qe-canvas-guide--horizontal {
  left: 0;
  right: 0;
  height: 9px;
  margin-top: -4px;
  cursor: ns-resize;
}

.qe-canvas-guide--horizontal::after {
  top: 4px;
  right: 0;
  left: 0;
  height: 1px;
}

.qe-canvas-guide:focus-visible::after,
.qe-canvas-guide:hover::after {
  background-color: #be185d;
  box-shadow: 0 0 0 2px rgba(190, 24, 93, 0.18);
}

.qe-canvas__hidden-area {
  position: absolute;
  left: 0;
  width: 100%;
  pointer-events: none;
  z-index: 1000;
}

.qe-canvas__hidden-area--top {
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.28),
    rgba(15, 23, 42, 0)
  );
}

.qe-canvas__hidden-area--bottom {
  bottom: 0;
  background: linear-gradient(
    0deg,
    rgba(15, 23, 42, 0.28),
    rgba(15, 23, 42, 0)
  );
}

.qe-canvas__element {
  position: absolute;
  background-color: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  color: var(--qe-text-primary);
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  will-change: transform, width, height;
}

.qe-canvas__element:active {
  cursor: grabbing;
}

.qe-canvas__element--dragging {
  cursor: grabbing;
  z-index: 9999;
}

.qe-canvas__element--selected {
  /* Show border and subtle background to indicate selected area */
  border: 2px dashed rgba(37, 99, 235, 0.6);
  background-color: rgba(37, 99, 235, 0.05);
  border-radius: 4px;
}

/* Geometric shapes use only the common outline selection indicator; their
   content box should not get an extra dashed selection border/background. */
.qe-canvas__element--shape[data-shape-geometric="true"].qe-canvas__element--selected,
.qe-canvas__element--shape.qe-canvas__element--selected {
  border: none;
  background-color: transparent;
}

/* Keep SVG stroke widths constant in screen pixels regardless of how big the
   shape element gets. Without this, a 2px stroke in a 100×100 viewBox visually
   grows to 20px when the element is sized 1000×1000. */
/* Keyed on the SVG's own class (not the editor wrapper) so it applies in the
   editor canvas AND in preview/render contexts alike. */
.qe-shape-svg rect,
.qe-shape-svg circle,
.qe-shape-svg ellipse,
.qe-shape-svg line,
.qe-shape-svg polygon,
.qe-shape-svg polyline,
.qe-shape-svg path {
  vector-effect: non-scaling-stroke;
  /* Round line caps so the "dotted" stroke (0-length dashes) renders as round
     dots rather than short bars. Closed shapes are unaffected. */
  stroke-linecap: round;
}

/* Enable text selection when editing rich text */
.qe-canvas__element .qe-rich-text-editor {
  user-select: text;
  -webkit-user-select: text;
  cursor: text;
}

/* Group element styles */
.qe-canvas__element--group {
  overflow: visible;
}

.qe-canvas__element--group.qe-canvas__element--selected {
  /* Distinctive border for selected group */
  border: 2px solid rgba(16, 185, 129, 0.8);
  background-color: rgba(16, 185, 129, 0.08);
  border-radius: 6px;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.qe-group {
  pointer-events: none;
}

.qe-canvas__element--media,
.qe-canvas__element--video,
.qe-canvas__element--drag {
  padding: 0;
  overflow: hidden;
}

.qe-canvas__element--audio {
  padding: 0;
  overflow: visible;
}

.qe-element__handle {
  display: inline-block;
  padding: 4px 10px;
  margin-bottom: 12px;
  background-color: rgba(37, 99, 235, 0.12);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--qe-accent);
}

.qe-element__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
}

.qe-element__body {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--qe-text-secondary);
}

.qe-token {
  display: inline-block;
  margin: 0 6px;
  padding: 2px 6px;
  background-color: rgba(37, 99, 235, 0.1);
  border-radius: 6px;
  font-weight: 600;
}

.qe-element__note {
  margin-top: 12px;
  font-size: 13px;
  color: var(--qe-text-muted);
  background-color: rgba(22, 163, 74, 0.08);
  border-radius: 8px;
  padding: 8px 10px;
}

.qe-media-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.12),
    rgba(79, 70, 229, 0.12)
  );
  border-radius: var(--qe-radius-base);
  color: var(--qe-text-secondary);
  font-weight: 600;
}

.qe-hotspot {
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(37, 99, 235, 0.9);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.qe-audio-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--qe-radius-base);
  background: rgba(37, 99, 235, 0.08);
}

.qe-audio-bar__icon {
  font-weight: 600;
  color: var(--qe-accent);
}

.qe-audio-bar__track {
  flex: 1 1;
  height: 6px;
  border-radius: 999px;
  background-color: rgba(37, 99, 235, 0.2);
  position: relative;
}

.qe-audio-bar__progress {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 40%;
  border-radius: 999px;
  background-color: var(--qe-accent);
}

.qe-audio-bar__time {
  font-size: 12px;
  color: var(--qe-text-muted);
}

.qe-choice-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border: none;
  border-radius: 0;
  margin-bottom: 8px;
  background-color: transparent;
}

.qe-canvas .qe-choice-option input[type="radio"],
.qe-canvas .qe-choice-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.qe-choice-option-group {
  display: flex;
  gap: 8px;
}

.qe-choice-option-group--vertical {
  flex-direction: column;
}

.qe-choice-option-group--horizontal {
  flex-direction: row;
  flex-wrap: wrap;
}

.qe-choice-option-group--horizontal .qe-choice-option {
  margin-bottom: 0;
  margin-right: 12px;
}

.qe-choice-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-choice-list__item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--qe-text-secondary);
}

.qe-fill-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
}

.qe-drag-board {
  display: flex;
  gap: 16px;
  padding: 16px;
}

.qe-drag-column {
  flex: 1 1;
  background-color: rgba(31, 36, 48, 0.03);
  border-radius: var(--qe-radius-base);
  padding: 12px;
  min-height: 140px;
}

.qe-drag-item {
  padding: 10px 12px;
  border-radius: 10px;
  background-color: var(--qe-bg-panel);
  border: 1px dashed rgba(31, 36, 48, 0.28);
  margin-bottom: 8px;
  text-align: center;
}

.qe-drop-zone {
  padding: 18px 12px;
  border-radius: 10px;
  border: 2px dashed rgba(37, 99, 235, 0.45);
  background-color: rgba(37, 99, 235, 0.04);
  margin-bottom: 12px;
  text-align: center;
  font-weight: 600;
  color: var(--qe-accent);
}

.qe-shape {
  width: 100%;
  height: calc(100% - 36px);
  min-height: 80px;
  border-radius: 16px;
  border: 2px solid rgba(15, 23, 42, 0.08);
  margin-top: 12px;
}

.qe-video-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--qe-border);
  background-color: rgba(15, 23, 42, 0.04);
}

.qe-button {
  border: 1px solid var(--qe-border);
  background-color: var(--qe-bg-panel);
  color: var(--qe-text-primary);
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease;
  white-space: nowrap;
}

.qe-button:hover:not(.qe-button--primary):not(.qe-button--danger) {
  background-color: rgba(37, 99, 235, 0.09);
  border-color: var(--qe-accent);
}

.qe-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.qe-button--primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.01em;
}

.qe-button--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
}

.qe-button--ghost {
  background-color: transparent;
}

.qe-button--danger {
  background-color: #dc2626;
  border-color: #dc2626;
  color: #ffffff;
}

.qe-button--danger:hover {
  background-color: #b91c1c;
  border-color: #b91c1c;
}

.qe-button--icon {
  padding: 6px 14px;
  min-width: 68px;
  font-weight: 600;
}

.qe-button--toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 34px;
  font-size: 13px;
  background-color: rgba(37, 99, 235, 0.12);
  border-color: rgba(37, 99, 235, 0.22);
  color: var(--qe-accent);
}

.qe-button--toggle[aria-pressed="false"] {
  background-color: transparent;
  border-color: var(--qe-border);
  color: var(--qe-text-secondary);
}

.qe-button--toggle:hover {
  background-color: rgba(37, 99, 235, 0.18);
  border-color: rgba(37, 99, 235, 0.32);
}

.qe-rail-toggle {
  position: absolute;
  top: 12px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background-color: #ffffff;
  color: var(--qe-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  z-index: 2;
}

.qe-rail-toggle--left {
  left: calc(var(--qe-panel-width-left) - 12px);
  right: auto;
}

.qe-rail--collapsed .qe-rail-toggle--left {
  left: -12px;
}

.qe-rail-toggle--right {
  left: auto;
  right: calc(var(--qe-panel-width-right) - 12px);
}

.qe-rail--collapsed .qe-rail-toggle--right {
  right: -12px;
}

.qe-rail-toggle:hover {
  border-color: rgba(37, 99, 235, 0.35);
  color: var(--qe-accent);
}

.qe-rail--collapsed {
  width: 20px;
  min-width: 20px;
  position: relative;
  border: none;
  background-color: transparent;
}

.qe-rail--collapsed .qe-panel {
  display: none;
}

.qe-button--delete {
  min-width: 32px;
  padding: 6px 8px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
}

.qe-button--compact {
  padding: 6px 12px;
  min-width: 0;
}

.qe-button--tiny {
  padding: 4px 8px;
  min-width: 0;
  font-size: 11px;
  line-height: 1.2;
}

.qe-icon-button {
  width: 36px;
  height: 36px;
  padding: 0;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.qe-icon-button svg {
  width: 18px;
  height: 18px;
}

.qe-icon-button--small {
  width: 24px;
  height: 24px;
  font-size: 12px;
}

.qe-icon-button--small svg {
  width: 12px;
  height: 12px;
}

.qe-panel {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--qe-border);
  position: relative;
  flex: 0 0 auto;
}

.qe-panel--elements {
  flex: 1 1;
  max-height: none;
}

.qe-panel--assets {
  flex: 0 0 auto;
  max-height: none;
  min-height: 0;
}

.qe-panel--properties {
  max-height: none;
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 0;
  height: auto;
  flex: 1 1;
}

.qe-panel--properties .qe-panel__content {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  overflow-anchor: none;
  display: flex;
  flex-direction: column;
  max-height: none;
}

.qe-properties-section {
  border: 1px solid var(--qe-border);
  border-radius: 12px;
  padding: 0;
  background-color: #ffffff;
  overflow: visible;
  transition: border-color 0.2s ease;
  min-height: auto;
}

/* Ensure non-choice sections maintain minimum height */
.qe-properties-section:not(.qe-properties-section--choice-options):not(
    .qe-properties-section--active
  ) {
  flex-shrink: 0;
  min-height: auto;
  max-height: none;
}

.qe-properties-section--active {
  border-color: #3b82f6;
  border-width: 2px;
}

.qe-properties-section + .qe-properties-section {
  margin-top: 12px;
}

/* Fix active section border overlap */
.qe-properties-section--active + .qe-properties-section,
.qe-properties-section + .qe-properties-section--active {
  margin-top: 14px;
}

.qe-properties-section__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--qe-text-muted);
  margin: 0;
  padding: 14px 16px;
}

.qe-panel__content--layers::-webkit-scrollbar-track {
  background-color: transparent;
}

.qe-properties-section__content-wrapper {
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
  opacity: 0;
  min-height: 0;
  max-height: 0;
}

.qe-properties-section__content-wrapper--open {
  opacity: 1;
  max-height: none !important;
  overflow: visible !important;
}

.qe-properties-section__content-wrapper--open.qe-properties-section__content-wrapper--choice-options {
  overflow: visible !important;
  max-height: none !important;
}

.qe-properties-section__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  min-height: 0;
  overflow: visible;
  opacity: 1 !important;
  position: relative;
  z-index: 1;
  max-height: none;
}

.qe-text-block {
  white-space: pre-wrap;
  word-break: break-word;
}

.qe-style-toggle-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.qe-style-toggle {
  border: 1px solid var(--qe-border);
  background-color: #ffffff;
  color: var(--qe-text-secondary);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease;
}

.qe-style-toggle:hover {
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-style-toggle--active {
  background-color: rgba(37, 99, 235, 0.12);
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-choice-config {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qe-choice-config__row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
}

.qe-choice-config__control {
  display: flex;
  align-items: center;
  justify-content: center;
}

.qe-choice-config__input {
  width: 100%;
}

.qe-modal {
  position: fixed;
  inset: 0;
  z-index: 20000; /* En yüksek z-index - her zaman en üstte */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
}

.qe-modal__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(2px);
  z-index: 0;
  cursor: pointer;
}

.qe-modal__content {
  position: relative;
  z-index: 1;
  width: 420px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  background: var(--qe-bg-panel);
  border-radius: 16px;
  box-shadow: 0 12px 38px rgba(15, 23, 42, 0.24);
  padding: 24px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  outline: none;
}

.qe-modal__content:focus {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25),
    0 12px 38px rgba(15, 23, 42, 0.24);
}

.qe-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.qe-modal__header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--qe-text-primary);
}

.qe-modal__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--qe-text-muted);
}

.qe-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  padding-right: 4px;
}

.qe-modal__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qe-modal__section h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--qe-text-secondary);
}

.qe-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.qe-modal__row {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qe-modal__row--spread {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qe-modal__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qe-modal__footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qe-modal__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-left: auto;
}

.qe-modal__backdrop[type="button"] {
  border: 0;
  padding: 0;
}

.qe-modal__content--tts {
  width: 520px;
}

.qe-tts-preview {
  max-height: 120px;
  overflow: auto;
  padding: 10px 12px;
  border: 1px solid var(--qe-border);
  border-radius: 8px;
  background: var(--qe-bg-surface);
  color: var(--qe-text-primary);
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-wrap;
}

.qe-tts-speed-value {
  font-size: 12px;
  font-weight: 600;
  color: var(--qe-text-secondary);
  font-variant-numeric: tabular-nums;
}

.qe-tts-speed-slider {
  width: 100%;
  accent-color: var(--qe-accent);
}

.qe-tts-speed-scale {
  display: flex;
  justify-content: space-between;
  color: var(--qe-text-muted);
  font-size: 11px;
}

.qe-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--qe-text-secondary);
  cursor: pointer;
}

.qe-toggle input {
  width: 18px;
  height: 18px;
}

@media (max-width: 540px) {
  .qe-modal {
    padding: 16px;
  }

  .qe-modal__content {
    width: 100%;
    max-height: calc(100vh - 32px);
  }

  .qe-modal__grid {
    grid-template-columns: 1fr;
  }

  .qe-modal__row--spread {
    flex-direction: column;
    align-items: stretch;
  }

  .qe-modal__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

.qe-preview {
  position: fixed;
  inset: 0;
  z-index: 20000; /* En yüksek z-index - her zaman en üstte */
  display: flex;
  align-items: center;
  justify-content: center;
}

.qe-preview__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(2px);
}

.qe-preview__content {
  position: relative;
  z-index: 1;
  width: calc(100vw - 32px);
  height: calc(100vh - 80px);
  margin: 40px 16px;
  background: var(--qe-bg-panel);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  padding: 24px 28px 32px;
  gap: 16px;
  outline: none;
}

.qe-preview__content:focus {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25),
    0 8px 32px rgba(15, 23, 42, 0.2);
}

.qe-preview__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.qe-preview__header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--qe-text-primary);
}

.qe-preview__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--qe-text-muted);
}

.qe-preview__canvas-wrapper {
  flex: 1 1;
  background: var(--qe-bg-surface);
  border-radius: 12px;
  padding: 24px;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.qe-preview__canvas {
  position: relative;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.qe-preview__element {
  border: none !important;
  box-shadow: none !important;
  cursor: default;
  background: transparent;
}
.qe-preview__element input[type="radio"],
.qe-preview__element input[type="checkbox"],
.qe-preview__element .qe-choice-option,
.qe-preview__element .qe-choice-option span,
.qe-preview__element .qe-drag-source,
.qe-preview__element .qe-drop-target,
.qe-preview__element .qe-drop-target__remove,
.qe-preview__element .qe-drag-item,
.qe-preview__element .qe-drop-zone,
.qe-preview__element .qe-drop-zone__remove {
  pointer-events: auto;
  cursor: pointer;
}

/* Drag Source Styles */
.qe-drag-source {
  padding: 10px 16px;
  background: #3b82f6;
  border: 2px solid #1d4ed8;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  text-align: center;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.qe-drag-source:active {
  cursor: grabbing;
}

.qe-drag-source--placed {
  opacity: 0.4;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #6b7280;
}

.qe-drag-source--disabled {
  opacity: 0.3;
  cursor: not-allowed !important;
  background: #6b7280 !important;
  border-color: #4b5563 !important;
  pointer-events: none;
}

.qe-drag-source--disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

.qe-drag-source--image {
  padding: 0;
  overflow: hidden;
}

.qe-drag-source__image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  border-radius: 6px;
}

/* Drop Target Styles */
.qe-drop-target {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}

.qe-drop-target__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.qe-properties-callout {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  background: none;
  border-bottom: none;
}

.qe-properties-callout__title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2430;
}

.qe-properties-subgroup {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0 0 0;
  border-bottom: none;
  margin-bottom: 0;
}

.qe-properties-subgroup:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

label.qe-properties-toggle {
  border: 1px solid #2563eb;
  background: rgba(37, 99, 235, 0.12);
  border-radius: 12px;
  padding: 10px 12px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1f2430;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

label.qe-properties-toggle:hover {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);
}

label.qe-properties-toggle input {
  transform: scale(1.2);
  accent-color: #2563eb;
}

label.qe-properties-toggle span {
  margin: 0;
}

.qe-drop-target__inner {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 16px;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.qe-drop-target__label {
  font-weight: 600;
  color: var(--qe-text-secondary);
  pointer-events: none;
  white-space: nowrap;
  text-align: center;
}

.qe-drop-target__content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.qe-drop-target__remove {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
}

.qe-drop-target__remove:hover {
  background: rgba(255, 255, 255, 0.3);
}

.qe-drop-target--with-image {
  /* Inline styles handle border rendering; keep modifier for semantic styling */
}

.qe-drop-target--with-image .qe-drop-target__label {
  background: rgba(248, 250, 252, 0.9);
  padding: 4px 8px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
}

/* Paint Area Styles */
.qe-paint-area--drag-over {
  background-color: rgba(37, 99, 235, 0.05);
  border-color: #2563eb;
}

/* Yanlış renkle boyandığında şekli titret (kısa geri bildirim). */
.qe-paint-area--shake {
  animation: qe-paint-shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes qe-paint-shake {
  10%,
  90% {
    transform: translateX(-2px);
  }
  20%,
  80% {
    transform: translateX(4px);
  }
  30%,
  50%,
  70% {
    transform: translateX(-8px);
  }
  40%,
  60% {
    transform: translateX(8px);
  }
}

.qe-paint-swatch {
  transition: transform 0.2s, box-shadow 0.2s;
}

.qe-paint-swatch:active {
  transform: scale(0.95);
}

.qe-paint-swatch:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Drag & Drop Styles */
.qe-drag-board {
  display: flex;
  gap: 20px;
  height: 100%;
}

.qe-drag-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-drag-header {
  font-weight: 600;
  font-size: 14px;
  color: var(--qe-text-primary);
  padding: 8px;
  background: var(--qe-bg-surface);
  border-radius: 6px;
  text-align: center;
}

.qe-drag-item {
  padding: 12px;
  background: #e1e9ff;
  border: 2px solid #2563eb;
  border-radius: 8px;
  text-align: center;
  font-weight: 500;
  color: #2563eb;
  cursor: grab;
  transition: all 0.2s;
}

.qe-drag-item:hover {
  background: #dbeafe;
  transform: translateY(-1px);
}

.qe-drag-item:active {
  cursor: grabbing;
}

.qe-drag-item--placed {
  opacity: 0.5;
  cursor: not-allowed;
}

.qe-drop-zone {
  min-height: 60px;
  padding: 12px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 0.2s;
}

.qe-drop-zone:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.qe-drop-zone__label {
  font-weight: 500;
  color: var(--qe-text-secondary);
  margin-bottom: 4px;
}

.qe-drop-zone__content {
  background: #16a34a;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.qe-drop-zone__remove {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}

.qe-drop-zone__remove:hover {
  background: rgba(255, 255, 255, 0.3);
}

.qe-preview__element .qe-element__handle {
  display: none;
}

.qe-fullscreen-preview {
  position: fixed;
  inset: 0;
  z-index: 20000; /* En yüksek z-index - her zaman en üstte */
  background: var(--qe-bg-surface);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  overflow: auto;
}

.qe-fullscreen-preview__content {
  position: relative;
  width: 100%;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
}

.qe-fullscreen-preview__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: var(--qe-bg-panel);
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.qe-fullscreen-preview__title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: var(--qe-text-primary);
}

.qe-fullscreen-preview__close {
  background: var(--qe-bg-panel);
  border: 1px solid var(--qe-border);
  color: var(--qe-text-primary);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  min-width: auto;
}

.qe-fullscreen-preview__close:hover {
  background: var(--qe-accent-muted);
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-fullscreen-preview__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qe-fullscreen-preview__check {
  background: var(--qe-accent);
  border: 1px solid var(--qe-accent);
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.qe-fullscreen-preview__check:hover {
  filter: brightness(0.95);
}

/* Answer-check result banner */
.qe-preview-check {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 36px 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  border: 1px solid var(--qe-border);
  background: var(--qe-bg-panel);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.qe-preview-check--success {
  border-color: #16a34a;
  background: #f0fdf4;
}

.qe-preview-check--warn {
  border-color: #f59e0b;
  background: #fffbeb;
}

.qe-preview-check--info {
  border-color: var(--qe-border);
  background: var(--qe-bg-panel);
}

.qe-preview-check__summary {
  font-size: 15px;
  font-weight: 600;
  color: var(--qe-text-primary);
}

.qe-preview-check__list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.qe-preview-check__item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  border: 1px solid var(--qe-border);
  background: #ffffff;
}

.qe-preview-check__item-label {
  color: var(--qe-text-secondary);
}

.qe-preview-check__item-status {
  font-weight: 600;
}

.qe-preview-check__item.is-correct {
  border-color: #16a34a;
}

.qe-preview-check__item.is-correct .qe-preview-check__item-status {
  color: #16a34a;
}

.qe-preview-check__item.is-wrong {
  border-color: #dc2626;
}

.qe-preview-check__item.is-wrong .qe-preview-check__item-status {
  color: #dc2626;
}

.qe-preview-check__item.is-empty {
  border-color: var(--qe-border);
}

.qe-preview-check__item.is-empty .qe-preview-check__item-status {
  color: var(--qe-text-muted);
}

.qe-preview-check__dismiss {
  position: absolute;
  top: 8px;
  right: 10px;
  border: none;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  color: var(--qe-text-muted);
  cursor: pointer;
}

.qe-preview-check__dismiss:hover {
  color: var(--qe-text-primary);
}

.qe-fullscreen-preview__canvas-wrapper {
  flex: 1 1;
  width: 100%;
  height: auto;
  min-height: 200px;
  padding: 20px 0;
}

.qe-fullscreen-preview__canvas {
  position: relative;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.qe-preview-only {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: var(--qe-bg-surface, #f1f5f9);
}

.qe-preview-only__canvas-wrapper {
  width: 100%;
  max-width: 960px;
  background: white;
  border-radius: 16px;
  box-shadow: var(--qe-shadow-lg, 0 10px 30px rgba(15, 23, 42, 0.08));
  padding: 24px;
  box-sizing: border-box;
}

.qe-preview-only__canvas {
  position: relative;
  margin: 0 auto;
  background: white;
  overflow: hidden;
}

.qe-preview-only__loader,
.qe-preview-only__message {
  font-size: 16px;
  color: #111827;
  background: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: var(--qe-shadow-md, 0 6px 20px rgba(15, 23, 42, 0.08));
}

.qe-preview-only__loader {
  font-weight: 600;
}

.qe-panel__title {
  padding: 18px 20px 12px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--qe-text-muted);
}

.qe-panel__content {
  padding: 0 20px 20px;
  font-size: 14px;
  color: var(--qe-text-secondary);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-panel__content--padded {
  padding: 16px 20px 20px;
  gap: 12px;
}

.qe-panel__content--scroll {
  flex: 1 1;
  overflow-y: auto;
}

.qe-panel__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qe-panel__section + .qe-panel__section {
  margin-top: 16px;
}

.qe-panel__subtitle {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--qe-text-muted);
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 6px;
}

.qe-properties-section__title--collapsible {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 14px 16px;
  margin: 0;
  background: none;
  border: none;
  width: 100%;
  transition: color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  pointer-events: auto;
}

.qe-properties-section__title--collapsible.qe-properties-section__title--open {
  color: var(--qe-accent);
}

.qe-properties-section__title--collapsible:hover {
  color: var(--qe-accent);
}

.qe-properties-section__icon {
  transition: transform 0.2s ease, color 0.2s ease;
  color: #6f7787;
  flex-shrink: 0;
  display: inline-block;
}

.qe-properties-section__icon--open {
  transform: rotate(180deg);
  color: var(--qe-accent);
}

.qe-properties-section .qe-form__label,
.qe-properties-section .qe-inline-input__label {
  -webkit-user-select: none;
          user-select: none;
}

.qe-properties-section .qe-input[readonly] {
  -webkit-user-select: none;
          user-select: none;
}

.qe-chip-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-pill {
  display: inline-block;
  width: auto;
  min-width: 100%;
  padding: 10px 12px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-sizing: border-box;
}

.qe-pill:hover {
  background-color: var(--qe-accent-muted);
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-pill.qe-pill--active {
  background-color: var(--qe-accent);
  border-color: var(--qe-accent);
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.2);
}

.qe-pill.qe-pill--active:hover {
  background-color: var(--qe-accent-hover);
  border-color: var(--qe-accent-hover);
  color: #ffffff;
}

.qe-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.qe-asset {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(217, 221, 231, 0.5);
}

.qe-asset:last-child {
  border-bottom: none;
}

.qe-asset__thumb {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.18),
    rgba(137, 87, 229, 0.18)
  );
}

.qe-asset__thumb--audio {
  background: linear-gradient(
    135deg,
    rgba(22, 163, 74, 0.2),
    rgba(37, 99, 235, 0.2)
  );
}

.qe-asset__thumb--video {
  background: linear-gradient(
    135deg,
    rgba(239, 170, 45, 0.2),
    rgba(37, 99, 235, 0.2)
  );
}

.qe-asset__thumb--svg {
  background: linear-gradient(
    135deg,
    rgba(147, 51, 234, 0.2),
    rgba(59, 130, 246, 0.2)
  );
}

.qe-asset__thumb--vector {
  background: linear-gradient(
    135deg,
    rgba(147, 51, 234, 0.2),
    rgba(59, 130, 246, 0.2)
  );
}

.qe-asset__name {
  font-weight: 600;
  color: var(--qe-text-primary);
}

.qe-asset__meta {
  font-size: 12px;
  color: var(--qe-text-muted);
}

.qe-form {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 0;
  overflow: visible;
  flex: 1 1;
  max-height: none;
}

.qe-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.qe-form__label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--qe-text-muted);
}

.qe-form__help {
  font-size: 11px;
  color: var(--qe-text-muted);
}

.qe-inline-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.qe-inline-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
}

.qe-inline-input {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.qe-inline-input__label {
  font-size: 11px;
  font-weight: 600;
  color: var(--qe-text-muted);
}

.qe-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--qe-border);
  background-color: #ffffff;
  font-size: 13px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.qe-input:focus {
  outline: none;
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.qe-input--color {
  padding: 4px;
  height: 48px;
  width: 80px;
}

.qe-input--textarea {
  resize: vertical;
  min-height: 90px;
}

.qe-chip-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.qe-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--qe-border);
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: var(--qe-text-secondary);
}

.qe-chip--active {
  background-color: rgba(37, 99, 235, 0.18);
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-chip__label {
  border: none;
  background: transparent;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.qe-chip__label:focus-visible {
  outline: 2px solid var(--qe-accent);
  outline-offset: 2px;
  border-radius: 999px;
}

.qe-chip__remove {
  border: none;
  background: transparent;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  opacity: 0.7;
}

.qe-chip__remove:hover {
  opacity: 1;
}

.qe-multi-select {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 100%;
}

.qe-multi-select__input {
  display: flex;
  gap: 8px;
}

.qe-multi-select__popover {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.qe-multi-select__create {
  margin-top: 6px;
  margin-bottom: 6px;
  padding: 6px 8px;
  border: 1px dashed var(--qe-border);
  border-radius: 6px;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 600;
  color: var(--qe-accent);
  text-align: left;
  cursor: pointer;
}

.qe-multi-select__list {
  width: 100%;
  border: 1px solid var(--qe-border);
  border-radius: 10px;
  background-color: #ffffff;
  padding: 6px;
  max-height: 220px;
  overflow-y: auto;
  box-sizing: border-box;
}

.qe-multi-select__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 8px;
}

.qe-multi-select__row:hover {
  background: rgba(37, 99, 235, 0.08);
}

.qe-multi-select__row--active {
  background: transparent;
}

.qe-multi-select__label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--qe-text-primary);
  cursor: pointer;
  flex: 1 1;
}

.qe-multi-select__checkbox {
  width: 16px;
  height: 16px;
}

.qe-multi-select__remove {
  border: none;
  background: transparent;
  padding: 4px;
  font: inherit;
  color: var(--qe-text-muted);
  cursor: pointer;
  opacity: 0.7;
}

.qe-multi-select__remove:hover {
  opacity: 1;
}

.qe-multi-select__empty {
  padding: 8px;
  font-size: 12px;
  color: var(--qe-text-muted);
}

.qe-mapping-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-mapping-table__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed rgba(31, 36, 48, 0.2);
  background-color: rgba(31, 36, 48, 0.02);
}

.qe-mapping-table__cell {
  font-size: 13px;
  color: var(--qe-text-primary);
}

.qe-icon-link {
  border: none;
  background: none;
  color: var(--qe-accent);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.qe-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--qe-text-secondary);
}

.qe-toggle input {
  width: 16px;
  height: 16px;
}

.qe-simple-list {
  margin: 0;
  padding-left: 18px;
  color: var(--qe-text-secondary);
  font-size: 13px;
}

.qe-simple-list li {
  margin-bottom: 4px;
}

.qe-layer-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background-color: #f8fafc;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  cursor: grab;
}

.qe-layer-item:active {
  cursor: grabbing;
}

.qe-layer-item--active {
  background-color: var(--qe-accent-muted);
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.qe-layer-item--active .qe-layer-item__name {
  color: var(--qe-accent);
  font-weight: 600;
}

.qe-layer-item:focus {
  outline: none;
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);
}

.qe-layer-item__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.qe-layer-item__name {
  font-weight: 600;
  color: var(--qe-text-secondary);
}

.qe-layer-item__meta {
  font-size: 12px;
  color: var(--qe-text-muted);
}

.qe-layer-item__actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.qe-layer-item--dragging {
  opacity: 0.9;
}

.qe-layer-item-drop-zone {
  height: 8px;
  position: relative;
}

.qe-layer-item-drop-zone:first-child {
  margin-top: -4px;
}

.qe-layer-item-drop-zone:last-child {
  margin-bottom: -4px;
}

.qe-layer-item-drop-zone:hover::after,
.qe-layer-item-drop-zone[aria-dragging="true"]::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  height: 2px;
  background-color: var(--qe-accent);
  z-index: 1;
}

.qe-layer-item-placeholder {
  height: 2px;
  background-color: var(--qe-accent);
  margin: 4px 12px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.qe-layer-item-placeholder--visible {
  opacity: 1;
}

.qe-icon-button {
  border: 1px solid var(--qe-border);
  background-color: #ffffff;
  color: var(--qe-text-secondary);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.qe-icon-button:hover {
  border-color: var(--qe-accent);
  color: var(--qe-accent);
}

.qe-layer-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.qe-layer-list::-webkit-scrollbar {
  width: 6px;
}

.qe-layer-list::-webkit-scrollbar-thumb {
  background-color: rgba(31, 36, 48, 0.18);
  border-radius: 4px;
}

.qe-layer-list::-webkit-scrollbar-track {
  background-color: transparent;
}

.qe-panel__content--scroll::-webkit-scrollbar {
  width: 8px;
}

.qe-panel__content--scroll::-webkit-scrollbar-thumb {
  background-color: rgba(31, 36, 48, 0.24);
  border-radius: 4px;
}

.qe-panel__content--scroll::-webkit-scrollbar-track {
  background-color: transparent;
}
.qe-color-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  width: 100%;
}

.qe-color-control__label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--qe-text-muted);
}

.qe-color-control__row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.qe-color-control__row .qe-input--color {
  width: 48px;
  height: 36px;
  padding: 4px;
  border: 1px solid var(--qe-border);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.qe-color-control__row .qe-button--tiny {
  margin: 0;
  flex-shrink: 0;
}

/* Standard color palette picker (öğe ayarlarındaki tüm renk kontrolleri) */
.qe-standard-color-picker,
.qe-standard-color-popover__swatch,
.qe-standard-color-popover__transparent {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--qe-border);
  border-radius: 7px;
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 2px #ffffff;
}

.qe-standard-color-picker {
  flex: 0 0 auto;
  background-clip: padding-box;
}

.qe-standard-color-picker:focus-visible,
.qe-standard-color-popover__swatch:focus-visible,
.qe-standard-color-popover__transparent:focus-visible {
  outline: none;
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18), inset 0 0 0 2px #ffffff;
}

.qe-standard-color-popover {
  position: fixed;
  z-index: 10000;
  padding: 8px;
  border: 1px solid rgba(148, 163, 184, 0.38);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.18);
}

.qe-standard-color-popover__toolbar {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.qe-standard-color-popover__transparent {
  width: 24px;
  height: 24px;
}

.qe-standard-color-popover__icon {
  width: 28px;
  height: 28px;
  border: 1px solid var(--qe-border);
  border-radius: 7px;
  background: #ffffff;
  color: var(--qe-text-secondary);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.qe-standard-color-popover__icon--active,
.qe-standard-color-popover__icon:hover {
  border-color: var(--qe-accent);
  color: var(--qe-accent);
  background: rgba(37, 99, 235, 0.08);
}

.qe-standard-color-popover__grid {
  display: grid;
  grid-template-columns: repeat(8, 24px);
  gap: 5px;
  justify-content: center;
}

.qe-standard-color-popover__swatch-wrap {
  width: 24px;
  height: 24px;
}

.qe-standard-color-popover__swatch--selected {
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.22), inset 0 0 0 2px #ffffff;
}

.qe-standard-color-popover__hex {
  width: 100%;
  min-height: 28px;
  margin-top: 8px;
  padding: 4px 8px;
  border: 1px solid var(--qe-border);
  border-radius: 7px;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}

/* Context Menu Styles */
.qe-context-menu {
  position: fixed;
  z-index: 250;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  padding: 4px 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.qe-context-menu__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: none;
  background: none;
  color: #1f2937;
  font-size: 13px;
  font-weight: 400;
  cursor: default;
  width: 100%;
  text-align: left;
  transition: none;
}

.qe-context-menu__item:hover {
  background-color: #2563eb;
  color: #ffffff;
}

.qe-context-menu__item--danger:hover {
  background-color: #dc2626;
  color: #ffffff;
}

.qe-context-menu__separator {
  height: 1px;
  background-color: #e5e7eb;
  margin: 4px 0;
}

/* Collapsible Sections */
.qe-collapsible {
  border-bottom: 1px solid #e5e7eb;
}

.qe-collapsible__toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--qe-text-primary);
  text-align: left;
  transition: background-color 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
}

.qe-collapsible__toggle:hover {
  background-color: #f8fafc;
}

.qe-collapsible__icon {
  font-size: 10px;
  color: var(--qe-text-muted);
  transition: transform 0.2s ease;
  font-family: monospace;
}

.qe-collapsible__content {
  padding: 0 16px 16px 16px;
}

/* Choice Options Editor Panel Styling */
.qe-properties-section__content .qe-choice-option {
  display: block;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.15s ease;
}

.qe-properties-section__content .qe-choice-option:hover {
  border-color: #cbd5e1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.qe-choice-option__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.qe-choice-option__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--qe-text-primary);
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qe-choice-option__remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #94a3b8;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  padding: 0;
}

.qe-choice-option__remove:hover {
  background: #fee2e2;
  color: #dc2626;
}

.qe-choice-option__remove svg {
  display: block;
}

.qe-choice-option__advanced {
  margin-top: 10px;
  border-top: 1px solid #f1f5f9;
  padding-top: 10px;
  overflow: visible;
  height: auto;
}

.qe-choice-option__advanced[open] {
  padding-bottom: 0;
}

.qe-choice-option__advanced-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--qe-text-muted);
  padding: 4px 0;
  transition: color 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
  list-style: none;
}

.qe-choice-option__advanced-trigger::-webkit-details-marker {
  display: none;
}

.qe-choice-option__advanced-trigger:hover {
  color: var(--qe-accent);
}

.qe-choice-option__advanced-trigger svg {
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.qe-choice-option__advanced[open] .qe-choice-option__advanced-trigger svg {
  transform: rotate(180deg);
}

.qe-choice-option__advanced-content {
  margin-top: 10px;
  overflow: visible;
  height: auto;
}

.qe-choice-option__advanced-content .qe-form__field {
  margin-bottom: 16px;
}

/* Notification Animation */
@keyframes slideIn {
  from {
    transform: translateX(-50%) translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.qe-choice-option__advanced-content .qe-form__field:last-child {
  margin-bottom: 0;
}

/* Reset margin for form fields inside other containers with spacing */
.qe-choice-option__advanced-content .qe-form__field,
.qe-properties-section__content .qe-form__field {
  margin-bottom: 16px;
}

.qe-choice-option__advanced-content .qe-form__field:last-child,
.qe-properties-section__content .qe-form__field:last-child {
  margin-bottom: 0;
}

/* Special handling for choice options section to allow expansion when open */
.qe-properties-section--choice-options.qe-properties-section--active {
  min-height: auto !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

/* Ensure choice options container can expand when open */
.qe-properties-section--choice-options.qe-properties-section--active
  .qe-properties-section__content-wrapper {
  overflow: visible !important;
  max-height: none !important;
}

.qe-properties-section--choice-options.qe-properties-section--active
  .qe-properties-section__content {
  overflow: visible !important;
  min-height: auto !important;
  height: auto !important;
}

/* Fallback for browsers without :has() support */
.qe-properties-section:has(.qe-choice-option).qe-properties-section--active {
  min-height: auto !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.qe-properties-section:has(.qe-choice-option).qe-properties-section--active
  .qe-properties-section__content-wrapper {
  overflow: visible !important;
  max-height: none !important;
}

.qe-properties-section:has(.qe-choice-option).qe-properties-section--active
  .qe-properties-section__content {
  overflow: visible !important;
  min-height: auto !important;
  height: auto !important;
}

/* Checkbox Label Styling */
.qe-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  color: var(--qe-text-primary);
  transition: color 0.15s ease;
}

.qe-checkbox-label:hover {
  color: var(--qe-text-secondary);
}

.qe-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #cbd5e1;
  cursor: pointer;
  transition: all 0.15s ease;
}

.qe-checkbox:hover {
  border-color: var(--qe-accent);
}

.qe-checkbox:checked {
  background-color: var(--qe-accent);
  border-color: var(--qe-accent);
}

/* Secondary Button */
.qe-button--secondary {
  background-color: #f8fafc;
  border-color: #e2e8f0;
  color: var(--qe-text-secondary);
  font-weight: 500;
}

.qe-button--secondary:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  color: var(--qe-text-primary);
}

/* Answer Key Styles */
.qe-answer-key-section {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.qe-answer-key-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.qe-answer-key-header strong {
  font-size: 14px;
  color: var(--qe-text-primary);
}

.qe-answer-key-type {
  font-size: 12px;
  color: var(--qe-text-muted);
  font-weight: 500;
}

.qe-answer-key-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-answer-key-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.qe-answer-key-option:hover {
  border-color: #cbd5e1;
  background-color: #fafbfc;
}

.qe-answer-key-option--selected {
  background-color: #e1e9ff;
  border-color: var(--qe-accent);
}

.qe-answer-key-option--selected:hover {
  background-color: #d4dff7;
}

.qe-answer-key-option input[type="checkbox"] {
  cursor: pointer;
}

.qe-answer-key-option-label {
  flex: 1 1;
  font-size: 14px;
  color: var(--qe-text-primary);
  font-weight: 500;
}

.qe-answer-key-option-value {
  font-size: 12px;
  color: var(--qe-text-muted);
  font-family: "Courier New", monospace;
}

/* Layer Drag and Drop Styles */
.qe-layer-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f8fafc;
  position: relative;
}

.qe-layer-item:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.qe-layer-item:last-child {
  border-bottom: none;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.qe-layer-item:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.qe-layer-item--active {
  background-color: var(--qe-accent-muted);
  border-color: var(--qe-accent);
}

.qe-layer-item--active .qe-layer-item__name {
  color: var(--qe-accent);
  font-weight: 600;
}

.qe-layer-item--dragging {
  opacity: 0.6;
  transform: scale(0.98);
  cursor: grabbing;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  position: relative;
}

.qe-layer-item__drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--qe-text-muted);
  cursor: grab;
  border-radius: 3px;
  transition: all 0.15s ease;
}

.qe-layer-item__drag-handle:hover {
  background-color: #e5e7eb;
  color: var(--qe-text-secondary);
}

.qe-layer-item:active .qe-layer-item__drag-handle {
  cursor: grabbing;
}

.qe-layer-item__body {
  flex: 1 1;
  min-width: 0;
}

.qe-layer-item__name {
  font-size: 13px;
  font-weight: 500;
  color: var(--qe-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qe-layer-item__meta {
  font-size: 11px;
  color: var(--qe-text-muted);
  margin-top: 2px;
}

.qe-layer-item__actions {
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.qe-layer-item:hover .qe-layer-item__actions {
  opacity: 1;
}

/* Toast Notifications */
[data-sonner-toast][data-type="success"] {
  background-color: var(--qe-success) !important;
  border-color: var(--qe-success) !important;
  color: white !important;
}

[data-sonner-toast][data-type="success"] [data-icon] {
  color: white !important;
}

[data-sonner-toast][data-type="success"] [data-content] {
  color: white !important;
}

[data-sonner-toast][data-type="error"] {
  background-color: var(--qe-error) !important;
  border-color: var(--qe-error) !important;
  color: white !important;
}

[data-sonner-toast][data-type="error"] [data-icon] {
  color: white !important;
}

[data-sonner-toast][data-type="error"] [data-content] {
  color: white !important;
}

[data-sonner-toast][data-type="warning"] {
  background-color: var(--qe-warning) !important;
  border-color: var(--qe-warning) !important;
  color: white !important;
}

[data-sonner-toast][data-type="warning"] [data-icon] {
  color: white !important;
}

[data-sonner-toast][data-type="warning"] [data-content] {
  color: white !important;
}

/* Fade in animation for warning messages */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* Shortcuts Section */
.qe-shortcuts-section {
  padding: 12px;
}

.qe-shortcuts-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qe-shortcut-item {
  padding: 12px;
  background: var(--qe-bg-panel);
  border: 1px solid var(--qe-border);
  border-radius: 8px;
  transition: all 0.15s ease;
}

.qe-shortcut-item:hover {
  border-color: var(--qe-border-strong);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.qe-shortcut-item:hover .qe-shortcut-item__pin {
  opacity: 1;
}

.qe-shortcut-item__content {
  width: 100%;
}

.qe-shortcut-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.qe-shortcut-item__label {
  font-size: 13px;
  font-weight: 500;
  color: var(--qe-text-primary);
  flex: 1 1;
}

.qe-shortcut-item__pin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.qe-shortcut-item__pin:hover {
  opacity: 1;
  transform: scale(1.1);
}

.qe-shortcut-item__type {
  font-size: 11px;
  color: var(--qe-text-muted);
}

/* Modal Styles */
.qe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000; /* En yüksek z-index - her zaman en üstte */
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.qe-modal-content {
  background: var(--qe-bg-panel);
  border-radius: var(--qe-radius-base);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.qe-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--qe-border);
}

.qe-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--qe-text-primary);
}

.qe-modal-close {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: var(--qe-text-muted);
  border-radius: 6px;
  transition: all 0.2s;
}

.qe-modal-close:hover {
  background-color: var(--qe-bg-muted);
  color: var(--qe-text-primary);
}

.qe-modal-body {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
}

.qe-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid var(--qe-border);
  background-color: var(--qe-bg-surface);
}

.qe-modal-footer .qe-button {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  outline: none;
}

.qe-modal-footer .qe-button--primary {
  background-color: var(--qe-accent);
  color: white;
}

.qe-modal-footer .qe-button--primary:hover {
  background-color: var(--qe-accent-hover);
}

.qe-modal-footer .qe-button--secondary {
  background-color: transparent;
  color: var(--qe-text-secondary);
  border: 1px solid var(--qe-border);
}

.qe-modal-footer .qe-button--secondary:hover {
  background-color: var(--qe-bg-muted);
  border-color: var(--qe-border-strong);
}

/* Question Type Change Confirm Modal Styles */
.qe-modal__content--warning {
  width: 480px;
  max-width: calc(100vw - 32px);
}

.qe-modal__content--warning .qe-modal__header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--qe-border);
}

.qe-modal__header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(239, 170, 45, 0.15),
    rgba(239, 170, 45, 0.25)
  );
  color: var(--qe-warning);
  flex-shrink: 0;
}

.qe-modal__content--warning .qe-modal__header-content {
  flex: 1 1;
  min-width: 0;
}

.qe-modal__content--warning .qe-modal__title {
  margin: 0 0 4px 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--qe-text-primary);
  line-height: 1.3;
}

.qe-modal__content--warning .qe-modal__subtitle {
  margin: 0;
  font-size: 13px;
  color: var(--qe-text-muted);
  font-weight: 500;
}

.qe-modal__content--warning .qe-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 0;
}

.qe-modal__info-box {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.06),
    rgba(37, 99, 235, 0.1)
  );
  border: 1px solid rgba(37, 99, 235, 0.2);
  border-radius: 12px;
}

.qe-modal__info-icon {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--qe-accent);
  flex-shrink: 0;
  margin-top: 2px;
}

.qe-modal__info-content {
  flex: 1 1;
  min-width: 0;
}

.qe-modal__info-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--qe-text-primary);
}

.qe-modal__highlight {
  font-weight: 700;
  color: var(--qe-accent);
  font-size: 15px;
}

.qe-modal__change-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.qe-modal__change-text {
  margin: 0;
  font-size: 14px;
  color: var(--qe-text-secondary);
  font-weight: 500;
}

.qe-modal__type-change {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: var(--qe-bg-surface);
  border-radius: 12px;
  border: 1px solid var(--qe-border);
}

.qe-modal__type-badge {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  border-radius: 10px;
  background: white;
  border: 2px solid var(--qe-border);
  transition: all 0.2s ease;
}

.qe-modal__type-badge--current {
  border-color: rgba(111, 119, 135, 0.3);
}

.qe-modal__type-badge--new {
  border-color: var(--qe-accent);
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.05),
    rgba(37, 99, 235, 0.1)
  );
}

.qe-modal__type-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--qe-text-muted);
}

.qe-modal__type-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--qe-text-primary);
  line-height: 1.3;
}

.qe-modal__type-badge--new .qe-modal__type-name {
  color: var(--qe-accent);
}

.qe-modal__type-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--qe-text-muted);
  flex-shrink: 0;
}

.qe-modal__warning-box {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(
    135deg,
    rgba(239, 170, 45, 0.1),
    rgba(239, 170, 45, 0.15)
  );
  border: 1px solid rgba(239, 170, 45, 0.3);
  border-radius: 12px;
}

.qe-modal__warning-icon {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--qe-warning);
  flex-shrink: 0;
  margin-top: 2px;
}

.qe-modal__warning-content {
  flex: 1 1;
  min-width: 0;
}

.qe-modal__warning-title {
  display: block;
  margin: 0 0 6px 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--qe-warning);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.qe-modal__warning-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--qe-text-primary);
}

.qe-modal__content--warning .qe-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid var(--qe-border);
}

.qe-button--danger {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.25);
}

.qe-button--danger:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.35);
  transform: translateY(-1px);
}

.qe-button--danger:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.25);
}

/* Save Success Modal Styles - Modern Card Design */
.qe-modal__content--success {
  width: 520px;
  max-width: calc(100vw - 32px);
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: none;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.qe-modal__success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 32px;
}

/* Success Icon Animation */
.qe-modal__success-icon-wrapper {
  position: relative;
  margin-bottom: 24px;
  animation: successBounce 0.6s ease-out;
}

@keyframes successBounce {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.qe-modal__success-icon-large {
  color: #22c55e;
  display: block;
}

.qe-modal__success-check {
  animation: checkDraw 0.4s ease-out 0.3s both;
}

@keyframes checkDraw {
  0% {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
  }
  100% {
    stroke-dasharray: 50;
    stroke-dashoffset: 0;
  }
}

/* Success Heading */
.qe-modal__success-heading {
  text-align: center;
  margin-bottom: 32px;
}

.qe-modal__success-title {
  margin: 0 0 12px 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.qe-modal__success-message {
  margin: 0;
  font-size: 16px;
  color: var(--qe-text-secondary, #64748b);
  font-weight: 500;
}

/* Action Cards */
.qe-modal__action-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.qe-modal__action-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #ffffff;
  border: 2px solid transparent;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.qe-modal__action-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, transparent 0%, rgba(255, 255, 255, 0.5) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.qe-modal__action-card:hover::before {
  opacity: 1;
}

.qe-modal__action-card--continue {
  border-color: #e2e8f0;
  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
}

.qe-modal__action-card--continue:hover {
  border-color: #22c55e;
  box-shadow: 0 8px 25px -5px rgba(34, 197, 94, 0.3);
  transform: translateY(-2px);
}

.qe-modal__action-card--redirect {
  border-color: #e2e8f0;
  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);
}

.qe-modal__action-card--redirect:hover {
  border-color: #3b82f6;
  box-shadow: 0 8px 25px -5px rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
}

.qe-modal__action-card:active {
  transform: translateY(0);
}

.qe-modal__action-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.qe-modal__action-card--continue .qe-modal__action-card-icon {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: #ffffff;
}

.qe-modal__action-card--continue:hover .qe-modal__action-card-icon {
  transform: scale(1.1) rotate(-5deg);
}

.qe-modal__action-card--redirect .qe-modal__action-card-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #ffffff;
}

.qe-modal__action-card--redirect:hover .qe-modal__action-card-icon {
  transform: scale(1.1) rotate(5deg);
}

.qe-modal__action-card-content {
  flex: 1 1;
  min-width: 0;
}

.qe-modal__action-card-title {
  margin: 0 0 4px 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--qe-text-primary, #1e293b);
  transition: color 0.3s ease;
}

.qe-modal__action-card--continue:hover .qe-modal__action-card-title {
  color: #16a34a;
}

.qe-modal__action-card--redirect:hover .qe-modal__action-card-title {
  color: #2563eb;
}

.qe-modal__action-card-desc {
  margin: 0;
  font-size: 14px;
  color: var(--qe-text-muted, #94a3b8);
  font-weight: 500;
}

.qe-modal__action-card-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
  opacity: 0;
  transform: translateX(-8px);
  transition: all 0.3s ease;
}

.qe-modal__action-card--continue .qe-modal__action-card-arrow {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.qe-modal__action-card--redirect .qe-modal__action-card-arrow {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.qe-modal__action-card:hover .qe-modal__action-card-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* Responsive */
@media (max-width: 576px) {
  .qe-modal__content--success {
    width: 100%;
    max-width: calc(100vw - 16px);
    border-radius: 16px;
  }

  .qe-modal__success-container {
    padding: 32px 24px 24px;
  }

  .qe-modal__success-title {
    font-size: 24px;
  }

  .qe-modal__success-message {
    font-size: 15px;
  }

  .qe-modal__action-card {
    padding: 16px;
  }

  .qe-modal__action-card-icon {
    width: 48px;
    height: 48px;
  }

  .qe-modal__action-card-title {
    font-size: 16px;
  }

  .qe-modal__action-card-desc {
    font-size: 13px;
  }
}

/* Media Library Modal Styles */
.qe-modal__content--media-library {
  width: 800px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
}

.qe-media-library__search {
  margin-bottom: 20px;
}

.qe-media-library__loading,
.qe-media-library__error,
.qe-media-library__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: var(--qe-text-muted);
  font-size: 14px;
}

.qe-media-library__error {
  color: var(--qe-error);
}

.qe-media-library__groups {
  max-height: 500px;
  overflow-y: auto;
}

.qe-media-library__group {
  margin-bottom: 32px;
}

.qe-media-library__group:last-child {
  margin-bottom: 0;
}

.qe-media-library__group-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--qe-text);
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--qe-border);
}

.qe-media-library__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  padding: 4px;
}

.qe-media-library__item {
  position: relative;
  border: 2px solid var(--qe-border);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.qe-media-library__item:hover {
  border-color: var(--qe-accent);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  transform: translateY(-2px);
}

.qe-media-library__item--selected {
  border-color: var(--qe-accent);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.qe-media-library__item-image {
  width: 100%;
  aspect-ratio: 1;
  background: var(--qe-bg-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qe-media-library__item-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.qe-media-library__item-name {
  padding: 8px 12px 4px;
  font-size: 12px;
  color: var(--qe-text-secondary);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-top: 1px solid var(--qe-border);
  background: var(--qe-bg-surface);
  font-weight: 500;
}

.qe-media-library__item-size {
  padding: 0 12px 8px;
  font-size: 11px;
  color: var(--qe-text-muted);
  text-align: center;
  background: var(--qe-bg-surface);
}

.qe-template-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 12px 8px;
  background: var(--qe-bg-surface);
  justify-content: center;
}

.qe-template-tag {
  font-size: 10px;
  color: var(--qe-text-secondary);
  background: #e8edf7;
  border-radius: 999px;
  padding: 2px 8px;
  line-height: 1.2;
}

.qe-template-tag--more {
  background: transparent;
  border: 1px dashed var(--qe-border);
  color: var(--qe-text-muted);
}

.qe-media-library__item-check {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background: var(--qe-accent);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.qe-media-library__groups::-webkit-scrollbar {
  width: 8px;
}

.qe-media-library__groups::-webkit-scrollbar-thumb {
  background-color: rgba(31, 36, 48, 0.24);
  border-radius: 4px;
}

.qe-media-library__groups::-webkit-scrollbar-track {
  background-color: transparent;
}

/* Media Library Button */
.qe-media-library-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid var(--qe-border);
  border-radius: 8px;
  background: white;
  color: var(--qe-text-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.qe-media-library-button:hover:not(:disabled) {
  border-color: var(--qe-accent);
  background: var(--qe-accent-muted);
  color: var(--qe-accent);
}

.qe-media-library-button:active:not(:disabled) {
  transform: scale(0.98);
}

.qe-media-library-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: var(--qe-bg-surface);
  color: var(--qe-text-muted);
  border-color: var(--qe-border);
}

.qe-media-library-button:disabled:hover {
  border-color: var(--qe-border);
  background: var(--qe-bg-surface);
  color: var(--qe-text-muted);
}

.qe-media-library-button__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.qe-media-library-button--has-value {
  border-color: var(--qe-accent);
  background: var(--qe-accent-muted);
  color: var(--qe-accent);
}

.qe-media-library-button--has-value:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: var(--qe-border);
  background: var(--qe-bg-surface);
  color: var(--qe-text-muted);
}

/* Redirect Overlay */
.qe-redirect-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 36, 48, 0.85);
  backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: qe-redirect-overlay-fade-in 0.3s ease-out;
}

@keyframes qe-redirect-overlay-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.qe-redirect-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  color: #ffffff;
}

.qe-redirect-overlay__spinner {
  width: 64px;
  height: 64px;
  position: relative;
}

.qe-redirect-overlay__spinner-circle {
  width: 100%;
  height: 100%;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: qe-redirect-spinner-rotate 1s linear infinite;
}

@keyframes qe-redirect-spinner-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.qe-redirect-overlay__message {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  animation: qe-redirect-message-pulse 1.5s ease-in-out infinite;
}

@keyframes qe-redirect-message-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

/* Saving Overlay */
.qe-saving-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 36, 48, 0.85);
  backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: qe-saving-overlay-fade-in 0.3s ease-out;
}

@keyframes qe-saving-overlay-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.qe-saving-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  color: #ffffff;
}

.qe-saving-overlay__spinner {
  width: 64px;
  height: 64px;
  position: relative;
}

.qe-saving-overlay__spinner-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.qe-saving-overlay__spinner-circle {
  fill: none;
  stroke: #ffffff;
  stroke-width: 4;
  stroke-dasharray: 126; /* 2 * PI * r(20) ≈ 125.66 */
  stroke-dashoffset: 126;
  animation: qe-saving-spinner-dash 1.5s ease-in-out infinite;
  transform-origin: center;
}

@keyframes qe-saving-spinner-dash {
  0% {
    stroke-dasharray: 1, 126;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 66, 126;
    stroke-dashoffset: -32;
  }
  100% {
    stroke-dasharray: 66, 126;
    stroke-dashoffset: -126;
  }
}

.qe-saving-overlay__message {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  animation: qe-saving-message-pulse 1.5s ease-in-out infinite;
}

@keyframes qe-saving-message-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.qe-media-library-button--has-value:hover {
  background: rgba(37, 99, 235, 0.15);
}

/* Sound Library Modal Styles */
.qe-modal__content--sound-library {
  width: 700px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.qe-modal__content--sound-library .qe-modal__body {
  padding: 20px 24px;
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.qe-modal__content--sound-library .qe-modal__footer {
  padding: 16px 24px;
  border-top: 1px solid var(--qe-border);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.qe-sound-library__loading,
.qe-sound-library__error,
.qe-sound-library__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: var(--qe-text-muted);
  font-size: 14px;
}

.qe-sound-library__error {
  color: var(--qe-error);
}

/* Breadcrumb Navigation */
.qe-file-browser__breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  border: 1px solid var(--qe-border);
  border-radius: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.qe-file-browser__breadcrumb-item {
  padding: 8px 14px;
  border-radius: 8px;
  background: white;
  border: 1px solid var(--qe-border);
  color: var(--qe-text);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.qe-file-browser__breadcrumb-item:hover {
  background: var(--qe-accent);
  color: white;
  border-color: var(--qe-accent);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

.qe-file-browser__breadcrumb-separator {
  color: var(--qe-text-muted);
  font-size: 14px;
  font-weight: 500;
}

/* File Browser Content */
.qe-file-browser__content {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid var(--qe-border);
  border-radius: 10px;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Media library grid inside file browser content */
.qe-file-browser__content .qe-media-library__grid {
  padding: 0;
  margin-top: 8px;
}

.qe-file-browser__content::-webkit-scrollbar {
  width: 10px;
}

.qe-file-browser__content::-webkit-scrollbar-thumb {
  background-color: rgba(31, 36, 48, 0.2);
  border-radius: 5px;
  border: 2px solid #fafbfc;
}

.qe-file-browser__content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(31, 36, 48, 0.3);
}

.qe-file-browser__content::-webkit-scrollbar-track {
  background-color: transparent;
}

.qe-file-browser__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: var(--qe-text-muted);
  font-size: 14px;
}

.qe-file-browser__item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  border: 1px solid transparent;
  margin-bottom: 6px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.qe-file-browser__item--folder {
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
}

.qe-file-browser__item--folder:hover {
  /* No hover effects */
}

.qe-file-browser__item--file {
  color: var(--qe-text);
  background: white;
}

.qe-file-browser__item--file:hover {
  /* No background color change */
}

.qe-file-browser__item--selected {
  background: rgba(37, 99, 235, 0.1);
  border-color: var(--qe-accent);
  color: var(--qe-accent);
  font-weight: 500;
}

.qe-file-browser__icon {
  font-size: 22px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.qe-file-browser__name {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.qe-file-browser__count {
  font-size: 12px;
  color: var(--qe-text-muted);
  font-weight: 500;
  transition: color 0.2s ease;
}

.qe-file-browser__size {
  font-size: 12px;
  color: var(--qe-text-muted);
  transition: color 0.2s ease;
}

.qe-file-browser__arrow {
  color: var(--qe-text-muted);
  font-size: 16px;
  transition: all 0.2s ease;
}

.qe-file-browser__check {
  color: var(--qe-accent);
  font-weight: bold;
  font-size: 18px;
}

/* Play Button */
.qe-file-browser__play-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--qe-accent);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.qe-file-browser__play-btn:hover {
  background: #4338ca;
  transform: scale(1.05);
}

.qe-file-browser__play-btn:active {
  transform: scale(0.95);
}

.qe-file-browser__item--playing {
  border-color: var(--qe-accent);
  background: rgba(37, 99, 235, 0.05);
}

.qe-file-browser__item--playing .qe-file-browser__play-btn {
  background: #ef4444;
}

.qe-file-browser__item--playing .qe-file-browser__play-btn:hover {
  background: #dc2626;
}

/* Video Library Modal Styles */
.qe-modal__content--video-library {
  width: 700px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.qe-modal__content--video-library .qe-modal__body {
  padding: 20px 24px;
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.qe-modal__content--video-library .qe-modal__footer {
  padding: 16px 24px;
  border-top: 1px solid var(--qe-border);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.qe-video-library__loading,
.qe-video-library__error,
.qe-video-library__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: var(--qe-text-muted);
  font-size: 14px;
}

.qe-video-library__error {
  color: var(--qe-error);
}

/* Video Library Grid Layout */
.qe-video-library__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px 0;
}

.qe-video-library__card {
  border: 2px solid var(--qe-border);
  border-radius: 12px;
  overflow: hidden;
  background: white;
  transition: all 0.2s ease;
  cursor: pointer;
}

.qe-video-library__card:hover {
  border-color: #6366f1;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15);
  transform: translateY(-2px);
}

.qe-video-library__card--selected {
  border-color: #22c55e;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);
}

/* Video Thumbnail */
.qe-video-library__thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #1e293b;
  overflow: hidden;
}

.qe-video-library__preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.qe-video-library__play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.qe-video-library__play-overlay svg {
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.qe-video-library__play-overlay--hidden {
  opacity: 0;
}

.qe-video-library__selected-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #22c55e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.qe-video-library__selected-indicator svg {
  color: white;
  width: 14px;
  height: 14px;
}

/* Video Info */
.qe-video-library__info {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qe-video-library__name {
  font-size: 13px;
  font-weight: 500;
  color: var(--qe-text);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.2s ease;
}

.qe-video-library__name:hover {
  color: #6366f1;
}

.qe-video-library__size {
  font-size: 12px;
  color: var(--qe-text-muted);
}

.qe-video-library__select-btn {
  margin-top: 4px;
  padding: 6px 12px;
  border: 1px solid var(--qe-border);
  border-radius: 6px;
  background: white;
  color: var(--qe-text);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.qe-video-library__select-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.qe-video-library__select-btn--selected {
  background: #22c55e;
  border-color: #22c55e;
  color: white;
}

.qe-video-library__select-btn--selected:hover {
  background: #16a34a;
  border-color: #16a34a;
}

/* Image Preview Modal Styles */
.qe-modal__content--image-preview {
  width: 90vw;
  max-width: 1200px;
  max-height: 90vh;
}

.qe-modal__body--image-preview {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  max-height: calc(90vh - 140px);
  overflow: hidden;
}

.qe-image-preview__container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--qe-bg-surface);
  padding: 20px;
  min-height: 400px;
}

.qe-image-preview__image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/features/question-editor/QuestionEditor.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,6BAA6B;EAC7B;cACY;AACd;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,2CAA2C;EAC3C,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yDAA+Q;EAC/Q,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EAGf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;;;;;;;;KAcG;AACL;;AAEA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;;;;;;;;;;KAcG;AACL;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,MAAM;EACN;;;;GAIC;AACH;;AAEA;EACE,SAAS;EACT;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gEAAgE;EAChE,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;4EAC4E;AAC5E;;EAEE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;uDAEuD;AACvD;wDACwD;AACxD;;;;;;;EAOE,iCAAiC;EACjC;iEAC+D;EAC/D,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,oCAAoC;EACpC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf;mBACiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;;;EAGE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,2EAA2E;EAC3E,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;mBACiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,2CAA2C;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,2CAA2C;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;oCACkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;;;;;;;;;;EAUE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE,wEAAwE;AAC1E;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;;IAGE,2BAA2B;EAC7B;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,2CAA2C;EAC3D,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mEAAmE;EACnE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;;;EAGE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,sEAAsE;AACxE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf;+CAC6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,uCAAuC;EACvC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,4BAA4B;EAC5B,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,6CAA6C;IAC7C,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,2CAA2C;EAC3D,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC;wCACsC;EACtC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;EACD,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb;;;;GAIC;EACD,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb;;;;GAIC;EACD,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,6BAA6B;EAC7B,6DAA6D;EAC7D,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,8DAA8D;AAChE;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB,EAAE,4BAA4B;EACnD,sBAAsB;EACtB,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uDAAuD;EACvD,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;EAC9B,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C","sourcesContent":[":root {\n  --qe-bg-surface: #f5f7fb;\n  --qe-bg-panel: #ffffff;\n  --qe-border: #d9dde7;\n  --qe-border-strong: #b0b6c4;\n  --qe-text-primary: #1f2430;\n  --qe-text-secondary: #4a5260;\n  --qe-text-muted: #6f7787;\n  --qe-text: #1f2430;\n  --qe-accent: #2563eb;\n  --qe-accent-hover: #1d4ed8;\n  --qe-accent-muted: #e1e9ff;\n  --qe-bg-muted: #eef2ff;\n  --qe-success: #16a34a;\n  --qe-warning: #efaa2d;\n  --qe-error: #dc2626;\n  --qe-panel-width-left: 260px;\n  --qe-panel-width-right: 340px;\n  --qe-toolbar-height: 52px;\n  --qe-header-height: 60px;\n  --qe-radius-base: 12px;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  background-color: var(--qe-bg-surface);\n  color: var(--qe-text-primary);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n}\n\n.qe-app {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.qe-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 28px;\n  height: var(--qe-header-height);\n  background-color: var(--qe-bg-panel);\n  border-bottom: 1px solid var(--qe-border);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 20px;\n}\n\n.qe-header__title {\n  font-size: 20px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.qe-header__actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.qe-header__separator {\n  width: 1px;\n  height: 32px;\n  background-color: var(--qe-border);\n  margin: 0 8px;\n}\n\n.qe-header__toggles {\n  display: flex;\n  gap: 8px;\n}\n\n.qe-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.qe-rail {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--qe-bg-panel);\n  overflow: hidden;\n}\n\n.qe-rail--left {\n  width: var(--qe-panel-width-left);\n  border-right: 1px solid var(--qe-border);\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.qe-rail--right {\n  width: var(--qe-panel-width-right);\n  border-left: 1px solid var(--qe-border);\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-stage {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background-color: var(--qe-bg-surface);\n}\n\n.qe-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0 16px;\n  height: var(--qe-toolbar-height);\n  background-color: rgba(255, 255, 255, 0.88);\n  border-bottom: 1px solid var(--qe-border);\n  backdrop-filter: blur(8px);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 0;\n}\n\n.qe-toolbar::-webkit-scrollbar {\n  height: 6px;\n}\n\n.qe-toolbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.qe-toolbar::-webkit-scrollbar-thumb {\n  background: var(--qe-border);\n  border-radius: 3px;\n}\n\n.qe-toolbar::-webkit-scrollbar-thumb:hover {\n  background: var(--qe-border-strong);\n}\n\n.qe-toolbar__group {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 0 12px;\n  border-right: 1px solid var(--qe-border);\n  height: 100%;\n}\n\n.qe-toolbar__group:first-child {\n  padding-left: 0;\n}\n\n.qe-toolbar__group:last-child {\n  border-right: none;\n  padding-right: 0;\n}\n\n.qe-toolbar__label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--qe-text-muted);\n  white-space: nowrap;\n}\n\n.qe-toolbar__button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid var(--qe-border);\n  border-radius: 6px;\n  background: white;\n  color: var(--qe-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.qe-toolbar__button:hover {\n  background: var(--qe-bg-muted);\n  border-color: var(--qe-border-strong);\n  color: var(--qe-text-primary);\n}\n\n.qe-toolbar__button:active {\n  transform: scale(0.95);\n}\n\n.qe-toolbar__button--symbol {\n  min-width: 36px;\n  width: auto;\n  padding: 0 10px;\n  font-weight: 600;\n}\n\n.qe-toolbar__button--primary {\n  background: var(--qe-accent);\n  color: white;\n  border-color: var(--qe-accent);\n  padding: 0 16px;\n  width: auto;\n  height: 34px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.qe-toolbar__button--primary:hover {\n  background: var(--qe-accent-hover);\n  border-color: var(--qe-accent-hover);\n  color: white;\n}\n\n.qe-toolbar__button--active {\n  background: var(--qe-accent);\n  color: white;\n  border-color: var(--qe-accent);\n}\n\n.qe-toolbar__button--active:hover {\n  background: var(--qe-accent-hover);\n  border-color: var(--qe-accent-hover);\n}\n\n.qe-toolbar__button--text {\n  min-width: 50px;\n  width: auto;\n  padding: 0 8px;\n}\n\n.qe-toolbar__button--tiny {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.qe-toolbar__guide-preset {\n  display: inline-flex;\n  align-items: center;\n  min-width: 138px;\n  margin-left: 4px;\n}\n\n.qe-toolbar__guide-preset .qe-input {\n  height: 32px;\n  min-width: 138px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.qe-toolbar__shortcut {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex-shrink: 0;\n  min-width: 80px;\n  padding-left: 12px;\n  margin-left: 12px;\n  border-left: 1px solid var(--qe-border);\n}\n\n.qe-toolbar__shortcut-label {\n  font-size: 10px;\n  line-height: 1.2;\n  color: var(--qe-text-muted);\n  letter-spacing: 0.01em;\n  text-align: left;\n  max-width: 120px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.qe-toolbar__segment-group {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 4px;\n  border: 1px solid var(--qe-border);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.88);\n  gap: 2px;\n}\n\n.qe-toolbar__segment {\n  border: none;\n  background: transparent;\n  color: var(--qe-text-secondary);\n  font-size: 11px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.qe-toolbar__segment:hover {\n  background-color: var(--qe-bg-muted);\n  color: var(--qe-text-primary);\n}\n\n.qe-toolbar__segment--active {\n  background-color: var(--qe-accent);\n  color: #fff;\n}\n\n.qe-toolbar__segment--active:hover {\n  background-color: var(--qe-accent-hover);\n}\n\n.qe-toolbar__segment:focus-visible {\n  outline: 2px solid var(--qe-accent);\n  outline-offset: 1px;\n}\n\n.qe-toolbar__shortcut .qe-input,\n.qe-toolbar__shortcut .qe-toolbar__slider,\n.qe-toolbar__shortcut .qe-toolbar__toggle-input {\n  align-self: stretch;\n}\n\n.qe-toolbar__shortcut:first-of-type {\n  border-left: none;\n  padding-left: 0;\n  margin-left: 0;\n}\n\n.qe-input--readonly {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 12px;\n  border: 1px dashed var(--qe-border);\n  border-radius: 8px;\n  background-color: #f8fafc;\n  color: var(--qe-text-secondary);\n  font-size: 13px;\n}\n\n.qe-toolbar__shortcut .qe-input.qe-input--color {\n  padding: 0;\n  width: 32px;\n  height: 32px;\n}\n\n.qe-toolbar__toggle-input:focus-visible,\n.qe-toolbar__slider:focus-visible,\n.qe-input--small:focus-visible {\n  outline: 2px solid var(--qe-accent);\n  outline-offset: 2px;\n}\n\n.qe-toolbar__toggle-input {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.qe-toolbar__slider {\n  width: 100px;\n  cursor: pointer;\n}\n\n.qe-input--small {\n  height: 28px;\n  font-size: 12px;\n  padding: 4px 8px;\n  width: 70px;\n  border-radius: 4px;\n}\n\n.qe-input--small[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.qe-input--small[type=\"number\"]::-webkit-inner-spin-button,\n.qe-input--small[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\nselect.qe-input--small {\n  width: auto;\n  min-width: 120px;\n  max-width: 180px;\n  padding: 4px 28px 4px 8px;\n  background-image: url('data:image/svg+xml;charset=UTF-8,<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 4.5L6 7.5L9 4.5\" stroke=\"%23666\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Question settings bar (inline metadata entry, below the toolbar) */\n.qe-qsbar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 8px 16px;\n  background-color: rgba(248, 250, 252, 0.96);\n  border-bottom: 1px solid var(--qe-border);\n  position: sticky;\n  top: var(--qe-toolbar-height);\n  z-index: 4;\n}\n\n.qe-qsbar__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 8px 14px;\n}\n\n.qe-qsbar__field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.qe-qsbar__label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--qe-text-muted);\n  white-space: nowrap;\n}\n\n.qe-qsbar__readonly {\n  display: flex;\n  align-items: center;\n  min-width: 120px;\n  max-width: 180px;\n  height: 28px;\n  min-height: 28px;\n  padding: 4px 8px;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.qe-qsbar__field--difficulty {\n  min-width: 150px;\n}\n\n.qe-qsbar__slider {\n  width: 100%;\n  min-width: 130px;\n  cursor: pointer;\n}\n\n.qe-qsbar__field--url {\n  flex: 0 1 190px;\n  min-width: 170px;\n  max-width: 210px;\n}\n\n.qe-qsbar__field--time .qe-input--small {\n  width: 80px;\n}\n\n.qe-qsbar__url-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.qe-qsbar__url-row .qe-input--small[type=\"url\"] {\n  flex: 1;\n  width: auto;\n  min-width: 0;\n}\n\n.qe-qsbar__mini-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid var(--qe-border);\n  border-radius: 4px;\n  background: white;\n  color: var(--qe-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.qe-qsbar__mini-button:hover:not(:disabled) {\n  border-color: var(--qe-border-strong);\n  color: var(--qe-text-primary);\n}\n\n.qe-qsbar__mini-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Toggles: single horizontal row so the bar stays short */\n.qe-qsbar__toggles {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 16px;\n  align-self: stretch;\n  padding-bottom: 4px;\n}\n\n.qe-qsbar__toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--qe-text-secondary);\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.qe-qsbar__toggle input {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\nselect.qe-input--small:hover {\n  border-color: var(--qe-border-strong);\n}\n\nselect.qe-input--small:focus {\n  outline: 2px solid var(--qe-accent);\n  outline-offset: -1px;\n}\n\n.qe-input--color.qe-input--small {\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.qe-toolbar__toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.qe-toolbar__toggle input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.qe-toolbar__toggle span {\n  font-size: 11px;\n  color: var(--qe-text-secondary);\n  white-space: nowrap;\n}\n\n.qe-toolbar__separator {\n  width: 1px;\n  height: 24px;\n  background: var(--qe-border);\n  margin: 0 4px;\n}\n\n/* Shortcutable Control */\n.qe-form__label-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.qe-shortcutable-control__pin {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  border-radius: 3px;\n  background: transparent;\n  color: var(--qe-text-muted);\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n  opacity: 0.3;\n}\n\n.qe-shortcutable-control__pin:hover {\n  opacity: 0.7;\n}\n\n.qe-shortcutable-control__pin--active {\n  color: var(--qe-accent);\n  opacity: 1;\n}\n\n.qe-shortcutable-control__pin--active:hover {\n  opacity: 0.8;\n}\n\n.qe-shortcutable-control__fallback {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.qe-canvas-shell {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  overflow: auto;\n}\n\n.qe-canvas-shell--media-drop {\n  background-color: rgba(37, 99, 235, 0.06);\n  box-shadow: inset 0 0 0 2px var(--qe-accent);\n}\n\n.qe-canvas {\n  position: relative;\n  display: inline-block;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.qe-canvas-ruler {\n  position: absolute;\n  z-index: 10030;\n  border: 1px solid var(--qe-border);\n  background-color: rgba(255, 255, 255, 0.94);\n  color: var(--qe-text-muted);\n  padding: 0;\n  font: inherit;\n  cursor: crosshair;\n  overflow: hidden;\n}\n\n.qe-canvas-ruler--horizontal {\n  top: -24px;\n  left: 0;\n  width: 100%;\n  height: 24px;\n  background-image:\n    repeating-linear-gradient(\n      90deg,\n      transparent 0,\n      transparent 9px,\n      rgba(71, 85, 105, 0.42) 9px,\n      rgba(71, 85, 105, 0.42) 10px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent 0,\n      transparent 49px,\n      rgba(37, 99, 235, 0.46) 49px,\n      rgba(37, 99, 235, 0.46) 50px\n    );\n}\n\n.qe-canvas-ruler--vertical {\n  top: 0;\n  left: -24px;\n  width: 24px;\n  height: 100%;\n  background-image:\n    repeating-linear-gradient(\n      0deg,\n      transparent 0,\n      transparent 9px,\n      rgba(71, 85, 105, 0.42) 9px,\n      rgba(71, 85, 105, 0.42) 10px\n    ),\n    repeating-linear-gradient(\n      0deg,\n      transparent 0,\n      transparent 49px,\n      rgba(37, 99, 235, 0.46) 49px,\n      rgba(37, 99, 235, 0.46) 50px\n    );\n}\n\n.qe-canvas-ruler__corner {\n  position: absolute;\n  top: -24px;\n  left: -24px;\n  z-index: 10031;\n  width: 24px;\n  height: 24px;\n  border: 1px solid var(--qe-border);\n  background-color: rgba(255, 255, 255, 0.96);\n}\n\n.qe-canvas-ruler__label {\n  position: absolute;\n  top: 3px;\n  color: #475569;\n  font-size: 9px;\n  line-height: 1;\n  letter-spacing: 0;\n  pointer-events: none;\n}\n\n.qe-canvas-ruler--horizontal .qe-canvas-ruler__label {\n  transform: translateX(3px);\n}\n\n.qe-canvas-ruler--vertical .qe-canvas-ruler__label {\n  left: 3px;\n  transform: rotate(-90deg) translateX(-100%);\n  transform-origin: top left;\n}\n\n.qe-canvas-guide {\n  position: absolute;\n  z-index: 10020;\n  border: 0;\n  touch-action: none;\n}\n\n.qe-canvas-guide::after {\n  content: \"\";\n  position: absolute;\n  background-color: #db2777;\n  box-shadow: 0 0 0 1px rgba(219, 39, 119, 0.16);\n}\n\n.qe-canvas-guide--vertical {\n  top: 0;\n  bottom: 0;\n  width: 9px;\n  margin-left: -4px;\n  cursor: ew-resize;\n}\n\n.qe-canvas-guide--vertical::after {\n  top: 0;\n  bottom: 0;\n  left: 4px;\n  width: 1px;\n}\n\n.qe-canvas-guide--horizontal {\n  left: 0;\n  right: 0;\n  height: 9px;\n  margin-top: -4px;\n  cursor: ns-resize;\n}\n\n.qe-canvas-guide--horizontal::after {\n  top: 4px;\n  right: 0;\n  left: 0;\n  height: 1px;\n}\n\n.qe-canvas-guide:focus-visible::after,\n.qe-canvas-guide:hover::after {\n  background-color: #be185d;\n  box-shadow: 0 0 0 2px rgba(190, 24, 93, 0.18);\n}\n\n.qe-canvas__hidden-area {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  pointer-events: none;\n  z-index: 1000;\n}\n\n.qe-canvas__hidden-area--top {\n  top: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(15, 23, 42, 0.28),\n    rgba(15, 23, 42, 0)\n  );\n}\n\n.qe-canvas__hidden-area--bottom {\n  bottom: 0;\n  background: linear-gradient(\n    0deg,\n    rgba(15, 23, 42, 0.28),\n    rgba(15, 23, 42, 0)\n  );\n}\n\n.qe-canvas__element {\n  position: absolute;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n  color: var(--qe-text-primary);\n  cursor: grab;\n  user-select: none;\n  touch-action: none;\n  will-change: transform, width, height;\n}\n\n.qe-canvas__element:active {\n  cursor: grabbing;\n}\n\n.qe-canvas__element--dragging {\n  cursor: grabbing;\n  z-index: 9999;\n}\n\n.qe-canvas__element--selected {\n  /* Show border and subtle background to indicate selected area */\n  border: 2px dashed rgba(37, 99, 235, 0.6);\n  background-color: rgba(37, 99, 235, 0.05);\n  border-radius: 4px;\n}\n\n/* Geometric shapes use only the common outline selection indicator; their\n   content box should not get an extra dashed selection border/background. */\n.qe-canvas__element--shape[data-shape-geometric=\"true\"].qe-canvas__element--selected,\n.qe-canvas__element--shape.qe-canvas__element--selected {\n  border: none;\n  background-color: transparent;\n}\n\n/* Keep SVG stroke widths constant in screen pixels regardless of how big the\n   shape element gets. Without this, a 2px stroke in a 100×100 viewBox visually\n   grows to 20px when the element is sized 1000×1000. */\n/* Keyed on the SVG's own class (not the editor wrapper) so it applies in the\n   editor canvas AND in preview/render contexts alike. */\n.qe-shape-svg rect,\n.qe-shape-svg circle,\n.qe-shape-svg ellipse,\n.qe-shape-svg line,\n.qe-shape-svg polygon,\n.qe-shape-svg polyline,\n.qe-shape-svg path {\n  vector-effect: non-scaling-stroke;\n  /* Round line caps so the \"dotted\" stroke (0-length dashes) renders as round\n     dots rather than short bars. Closed shapes are unaffected. */\n  stroke-linecap: round;\n}\n\n/* Enable text selection when editing rich text */\n.qe-canvas__element .qe-rich-text-editor {\n  user-select: text;\n  -webkit-user-select: text;\n  cursor: text;\n}\n\n/* Group element styles */\n.qe-canvas__element--group {\n  overflow: visible;\n}\n\n.qe-canvas__element--group.qe-canvas__element--selected {\n  /* Distinctive border for selected group */\n  border: 2px solid rgba(16, 185, 129, 0.8);\n  background-color: rgba(16, 185, 129, 0.08);\n  border-radius: 6px;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n}\n\n.qe-group {\n  pointer-events: none;\n}\n\n.qe-canvas__element--media,\n.qe-canvas__element--video,\n.qe-canvas__element--drag {\n  padding: 0;\n  overflow: hidden;\n}\n\n.qe-canvas__element--audio {\n  padding: 0;\n  overflow: visible;\n}\n\n.qe-element__handle {\n  display: inline-block;\n  padding: 4px 10px;\n  margin-bottom: 12px;\n  background-color: rgba(37, 99, 235, 0.12);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--qe-accent);\n}\n\n.qe-element__title {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.qe-element__body {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--qe-text-secondary);\n}\n\n.qe-token {\n  display: inline-block;\n  margin: 0 6px;\n  padding: 2px 6px;\n  background-color: rgba(37, 99, 235, 0.1);\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n.qe-element__note {\n  margin-top: 12px;\n  font-size: 13px;\n  color: var(--qe-text-muted);\n  background-color: rgba(22, 163, 74, 0.08);\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n\n.qe-media-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(37, 99, 235, 0.12),\n    rgba(79, 70, 229, 0.12)\n  );\n  border-radius: var(--qe-radius-base);\n  color: var(--qe-text-secondary);\n  font-weight: 600;\n}\n\n.qe-hotspot {\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: rgba(37, 99, 235, 0.9);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n}\n\n.qe-audio-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: var(--qe-radius-base);\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.qe-audio-bar__icon {\n  font-weight: 600;\n  color: var(--qe-accent);\n}\n\n.qe-audio-bar__track {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background-color: rgba(37, 99, 235, 0.2);\n  position: relative;\n}\n\n.qe-audio-bar__progress {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 40%;\n  border-radius: 999px;\n  background-color: var(--qe-accent);\n}\n\n.qe-audio-bar__time {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n}\n\n.qe-choice-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border: none;\n  border-radius: 0;\n  margin-bottom: 8px;\n  background-color: transparent;\n}\n\n.qe-canvas .qe-choice-option input[type=\"radio\"],\n.qe-canvas .qe-choice-option input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n}\n\n.qe-choice-option-group {\n  display: flex;\n  gap: 8px;\n}\n\n.qe-choice-option-group--vertical {\n  flex-direction: column;\n}\n\n.qe-choice-option-group--horizontal {\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.qe-choice-option-group--horizontal .qe-choice-option {\n  margin-bottom: 0;\n  margin-right: 12px;\n}\n\n.qe-choice-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-choice-list__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--qe-text-secondary);\n}\n\n.qe-fill-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 14px;\n}\n\n.qe-drag-board {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n}\n\n.qe-drag-column {\n  flex: 1;\n  background-color: rgba(31, 36, 48, 0.03);\n  border-radius: var(--qe-radius-base);\n  padding: 12px;\n  min-height: 140px;\n}\n\n.qe-drag-item {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background-color: var(--qe-bg-panel);\n  border: 1px dashed rgba(31, 36, 48, 0.28);\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.qe-drop-zone {\n  padding: 18px 12px;\n  border-radius: 10px;\n  border: 2px dashed rgba(37, 99, 235, 0.45);\n  background-color: rgba(37, 99, 235, 0.04);\n  margin-bottom: 12px;\n  text-align: center;\n  font-weight: 600;\n  color: var(--qe-accent);\n}\n\n.qe-shape {\n  width: 100%;\n  height: calc(100% - 36px);\n  min-height: 80px;\n  border-radius: 16px;\n  border: 2px solid rgba(15, 23, 42, 0.08);\n  margin-top: 12px;\n}\n\n.qe-video-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid var(--qe-border);\n  background-color: rgba(15, 23, 42, 0.04);\n}\n\n.qe-button {\n  border: 1px solid var(--qe-border);\n  background-color: var(--qe-bg-panel);\n  color: var(--qe-text-primary);\n  border-radius: 8px;\n  padding: 8px 18px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease,\n    color 0.2s ease;\n  white-space: nowrap;\n}\n\n.qe-button:hover:not(.qe-button--primary):not(.qe-button--danger) {\n  background-color: rgba(37, 99, 235, 0.09);\n  border-color: var(--qe-accent);\n}\n\n.qe-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.qe-button--primary {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.01em;\n}\n\n.qe-button--primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);\n}\n\n.qe-button--ghost {\n  background-color: transparent;\n}\n\n.qe-button--danger {\n  background-color: #dc2626;\n  border-color: #dc2626;\n  color: #ffffff;\n}\n\n.qe-button--danger:hover {\n  background-color: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.qe-button--icon {\n  padding: 6px 14px;\n  min-width: 68px;\n  font-weight: 600;\n}\n\n.qe-button--toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  height: 34px;\n  font-size: 13px;\n  background-color: rgba(37, 99, 235, 0.12);\n  border-color: rgba(37, 99, 235, 0.22);\n  color: var(--qe-accent);\n}\n\n.qe-button--toggle[aria-pressed=\"false\"] {\n  background-color: transparent;\n  border-color: var(--qe-border);\n  color: var(--qe-text-secondary);\n}\n\n.qe-button--toggle:hover {\n  background-color: rgba(37, 99, 235, 0.18);\n  border-color: rgba(37, 99, 235, 0.32);\n}\n\n.qe-rail-toggle {\n  position: absolute;\n  top: 12px;\n  right: -12px;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  background-color: #ffffff;\n  color: var(--qe-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);\n  z-index: 2;\n}\n\n.qe-rail-toggle--left {\n  left: calc(var(--qe-panel-width-left) - 12px);\n  right: auto;\n}\n\n.qe-rail--collapsed .qe-rail-toggle--left {\n  left: -12px;\n}\n\n.qe-rail-toggle--right {\n  left: auto;\n  right: calc(var(--qe-panel-width-right) - 12px);\n}\n\n.qe-rail--collapsed .qe-rail-toggle--right {\n  right: -12px;\n}\n\n.qe-rail-toggle:hover {\n  border-color: rgba(37, 99, 235, 0.35);\n  color: var(--qe-accent);\n}\n\n.qe-rail--collapsed {\n  width: 20px;\n  min-width: 20px;\n  position: relative;\n  border: none;\n  background-color: transparent;\n}\n\n.qe-rail--collapsed .qe-panel {\n  display: none;\n}\n\n.qe-button--delete {\n  min-width: 32px;\n  padding: 6px 8px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.qe-button--compact {\n  padding: 6px 12px;\n  min-width: 0;\n}\n\n.qe-button--tiny {\n  padding: 4px 8px;\n  min-width: 0;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n.qe-icon-button {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.qe-icon-button svg {\n  width: 18px;\n  height: 18px;\n}\n\n.qe-icon-button--small {\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n}\n\n.qe-icon-button--small svg {\n  width: 12px;\n  height: 12px;\n}\n\n.qe-panel {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid var(--qe-border);\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.qe-panel--elements {\n  flex: 1;\n  max-height: none;\n}\n\n.qe-panel--assets {\n  flex: 0 0 auto;\n  max-height: none;\n  min-height: 0;\n}\n\n.qe-panel--properties {\n  max-height: none;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  min-height: 0;\n  height: auto;\n  flex: 1;\n}\n\n.qe-panel--properties .qe-panel__content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  overflow-anchor: none;\n  display: flex;\n  flex-direction: column;\n  max-height: none;\n}\n\n.qe-properties-section {\n  border: 1px solid var(--qe-border);\n  border-radius: 12px;\n  padding: 0;\n  background-color: #ffffff;\n  overflow: visible;\n  transition: border-color 0.2s ease;\n  min-height: auto;\n}\n\n/* Ensure non-choice sections maintain minimum height */\n.qe-properties-section:not(.qe-properties-section--choice-options):not(\n    .qe-properties-section--active\n  ) {\n  flex-shrink: 0;\n  min-height: auto;\n  max-height: none;\n}\n\n.qe-properties-section--active {\n  border-color: #3b82f6;\n  border-width: 2px;\n}\n\n.qe-properties-section + .qe-properties-section {\n  margin-top: 12px;\n}\n\n/* Fix active section border overlap */\n.qe-properties-section--active + .qe-properties-section,\n.qe-properties-section + .qe-properties-section--active {\n  margin-top: 14px;\n}\n\n.qe-properties-section__title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--qe-text-muted);\n  margin: 0;\n  padding: 14px 16px;\n}\n\n.qe-panel__content--layers::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.qe-properties-section__content-wrapper {\n  overflow: hidden;\n  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;\n  opacity: 0;\n  min-height: 0;\n  max-height: 0;\n}\n\n.qe-properties-section__content-wrapper--open {\n  opacity: 1;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.qe-properties-section__content-wrapper--open.qe-properties-section__content-wrapper--choice-options {\n  overflow: visible !important;\n  max-height: none !important;\n}\n\n.qe-properties-section__content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  min-height: 0;\n  overflow: visible;\n  opacity: 1 !important;\n  position: relative;\n  z-index: 1;\n  max-height: none;\n}\n\n.qe-text-block {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.qe-style-toggle-group {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.qe-style-toggle {\n  border: 1px solid var(--qe-border);\n  background-color: #ffffff;\n  color: var(--qe-text-secondary);\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.qe-style-toggle:hover {\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-style-toggle--active {\n  background-color: rgba(37, 99, 235, 0.12);\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-choice-config {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.qe-choice-config__row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.qe-choice-config__control {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qe-choice-config__input {\n  width: 100%;\n}\n\n.qe-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 20000; /* En yüksek z-index - her zaman en üstte */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n}\n\n.qe-modal__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.48);\n  backdrop-filter: blur(2px);\n  z-index: 0;\n  cursor: pointer;\n}\n\n.qe-modal__content {\n  position: relative;\n  z-index: 1;\n  width: 420px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 64px);\n  background: var(--qe-bg-panel);\n  border-radius: 16px;\n  box-shadow: 0 12px 38px rgba(15, 23, 42, 0.24);\n  padding: 24px 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  outline: none;\n}\n\n.qe-modal__content:focus {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25),\n    0 12px 38px rgba(15, 23, 42, 0.24);\n}\n\n.qe-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.qe-modal__header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n}\n\n.qe-modal__subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--qe-text-muted);\n}\n\n.qe-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.qe-modal__section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.qe-modal__section h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--qe-text-secondary);\n}\n\n.qe-modal__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.qe-modal__row {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.qe-modal__row--spread {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.qe-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.qe-modal__footer {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.qe-modal__actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-left: auto;\n}\n\n.qe-modal__backdrop[type=\"button\"] {\n  border: 0;\n  padding: 0;\n}\n\n.qe-modal__content--tts {\n  width: 520px;\n}\n\n.qe-tts-preview {\n  max-height: 120px;\n  overflow: auto;\n  padding: 10px 12px;\n  border: 1px solid var(--qe-border);\n  border-radius: 8px;\n  background: var(--qe-bg-surface);\n  color: var(--qe-text-primary);\n  font-size: 13px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.qe-tts-speed-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--qe-text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n.qe-tts-speed-slider {\n  width: 100%;\n  accent-color: var(--qe-accent);\n}\n\n.qe-tts-speed-scale {\n  display: flex;\n  justify-content: space-between;\n  color: var(--qe-text-muted);\n  font-size: 11px;\n}\n\n.qe-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--qe-text-secondary);\n  cursor: pointer;\n}\n\n.qe-toggle input {\n  width: 18px;\n  height: 18px;\n}\n\n@media (max-width: 540px) {\n  .qe-modal {\n    padding: 16px;\n  }\n\n  .qe-modal__content {\n    width: 100%;\n    max-height: calc(100vh - 32px);\n  }\n\n  .qe-modal__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .qe-modal__row--spread {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .qe-modal__actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n.qe-preview {\n  position: fixed;\n  inset: 0;\n  z-index: 20000; /* En yüksek z-index - her zaman en üstte */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qe-preview__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.48);\n  backdrop-filter: blur(2px);\n}\n\n.qe-preview__content {\n  position: relative;\n  z-index: 1;\n  width: calc(100vw - 32px);\n  height: calc(100vh - 80px);\n  margin: 40px 16px;\n  background: var(--qe-bg-panel);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.2);\n  display: flex;\n  flex-direction: column;\n  padding: 24px 28px 32px;\n  gap: 16px;\n  outline: none;\n}\n\n.qe-preview__content:focus {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25),\n    0 8px 32px rgba(15, 23, 42, 0.2);\n}\n\n.qe-preview__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.qe-preview__header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--qe-text-primary);\n}\n\n.qe-preview__subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--qe-text-muted);\n}\n\n.qe-preview__canvas-wrapper {\n  flex: 1;\n  background: var(--qe-bg-surface);\n  border-radius: 12px;\n  padding: 24px;\n  overflow: auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.qe-preview__canvas {\n  position: relative;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.qe-preview__element {\n  border: none !important;\n  box-shadow: none !important;\n  cursor: default;\n  background: transparent;\n}\n.qe-preview__element input[type=\"radio\"],\n.qe-preview__element input[type=\"checkbox\"],\n.qe-preview__element .qe-choice-option,\n.qe-preview__element .qe-choice-option span,\n.qe-preview__element .qe-drag-source,\n.qe-preview__element .qe-drop-target,\n.qe-preview__element .qe-drop-target__remove,\n.qe-preview__element .qe-drag-item,\n.qe-preview__element .qe-drop-zone,\n.qe-preview__element .qe-drop-zone__remove {\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n/* Drag Source Styles */\n.qe-drag-source {\n  padding: 10px 16px;\n  background: #3b82f6;\n  border: 2px solid #1d4ed8;\n  border-radius: 8px;\n  color: white;\n  font-weight: 500;\n  text-align: center;\n  cursor: grab;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.qe-drag-source:active {\n  cursor: grabbing;\n}\n\n.qe-drag-source--placed {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: #9ca3af;\n  border-color: #6b7280;\n}\n\n.qe-drag-source--disabled {\n  opacity: 0.3;\n  cursor: not-allowed !important;\n  background: #6b7280 !important;\n  border-color: #4b5563 !important;\n  pointer-events: none;\n}\n\n.qe-drag-source--disabled:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.qe-drag-source--image {\n  padding: 0;\n  overflow: hidden;\n}\n\n.qe-drag-source__image {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 6px;\n}\n\n/* Drop Target Styles */\n.qe-drop-target {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.qe-drop-target__image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  pointer-events: none;\n}\n\n.qe-properties-callout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0;\n  background: none;\n  border-bottom: none;\n}\n\n.qe-properties-callout__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2430;\n}\n\n.qe-properties-subgroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0 0 0;\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.qe-properties-subgroup:last-of-type {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\nlabel.qe-properties-toggle {\n  border: 1px solid #2563eb;\n  background: rgba(37, 99, 235, 0.12);\n  border-radius: 12px;\n  padding: 10px 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2430;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\nlabel.qe-properties-toggle:hover {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);\n}\n\nlabel.qe-properties-toggle input {\n  transform: scale(1.2);\n  accent-color: #2563eb;\n}\n\nlabel.qe-properties-toggle span {\n  margin: 0;\n}\n\n.qe-drop-target__inner {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  border: 2px dashed #cbd5e1;\n  border-radius: 12px;\n  background: #f8fafc;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n}\n\n.qe-drop-target__label {\n  font-weight: 600;\n  color: var(--qe-text-secondary);\n  pointer-events: none;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.qe-drop-target__content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.qe-drop-target__remove {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.qe-drop-target__remove:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.qe-drop-target--with-image {\n  /* Inline styles handle border rendering; keep modifier for semantic styling */\n}\n\n.qe-drop-target--with-image .qe-drop-target__label {\n  background: rgba(248, 250, 252, 0.9);\n  padding: 4px 8px;\n  border-radius: 6px;\n  backdrop-filter: blur(4px);\n}\n\n/* Paint Area Styles */\n.qe-paint-area--drag-over {\n  background-color: rgba(37, 99, 235, 0.05);\n  border-color: #2563eb;\n}\n\n/* Yanlış renkle boyandığında şekli titret (kısa geri bildirim). */\n.qe-paint-area--shake {\n  animation: qe-paint-shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n}\n\n@keyframes qe-paint-shake {\n  10%,\n  90% {\n    transform: translateX(-2px);\n  }\n  20%,\n  80% {\n    transform: translateX(4px);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translateX(-8px);\n  }\n  40%,\n  60% {\n    transform: translateX(8px);\n  }\n}\n\n.qe-paint-swatch {\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.qe-paint-swatch:active {\n  transform: scale(0.95);\n}\n\n.qe-paint-swatch:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Drag & Drop Styles */\n.qe-drag-board {\n  display: flex;\n  gap: 20px;\n  height: 100%;\n}\n\n.qe-drag-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-drag-header {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--qe-text-primary);\n  padding: 8px;\n  background: var(--qe-bg-surface);\n  border-radius: 6px;\n  text-align: center;\n}\n\n.qe-drag-item {\n  padding: 12px;\n  background: #e1e9ff;\n  border: 2px solid #2563eb;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 500;\n  color: #2563eb;\n  cursor: grab;\n  transition: all 0.2s;\n}\n\n.qe-drag-item:hover {\n  background: #dbeafe;\n  transform: translateY(-1px);\n}\n\n.qe-drag-item:active {\n  cursor: grabbing;\n}\n\n.qe-drag-item--placed {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.qe-drop-zone {\n  min-height: 60px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 2px dashed #cbd5e1;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.qe-drop-zone:hover {\n  border-color: #94a3b8;\n  background: #f1f5f9;\n}\n\n.qe-drop-zone__label {\n  font-weight: 500;\n  color: var(--qe-text-secondary);\n  margin-bottom: 4px;\n}\n\n.qe-drop-zone__content {\n  background: #16a34a;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-weight: 500;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.qe-drop-zone__remove {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.qe-drop-zone__remove:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.qe-preview__element .qe-element__handle {\n  display: none;\n}\n\n.qe-fullscreen-preview {\n  position: fixed;\n  inset: 0;\n  z-index: 20000; /* En yüksek z-index - her zaman en üstte */\n  background: var(--qe-bg-surface);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 20px;\n  overflow: auto;\n}\n\n.qe-fullscreen-preview__content {\n  position: relative;\n  width: 100%;\n  max-width: calc(100vw - 40px);\n  max-height: calc(100vh - 40px);\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-fullscreen-preview__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: var(--qe-bg-panel);\n  border-radius: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.qe-fullscreen-preview__title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  color: var(--qe-text-primary);\n}\n\n.qe-fullscreen-preview__close {\n  background: var(--qe-bg-panel);\n  border: 1px solid var(--qe-border);\n  color: var(--qe-text-primary);\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  min-width: auto;\n}\n\n.qe-fullscreen-preview__close:hover {\n  background: var(--qe-accent-muted);\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-fullscreen-preview__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.qe-fullscreen-preview__check {\n  background: var(--qe-accent);\n  border: 1px solid var(--qe-accent);\n  color: #ffffff;\n  border-radius: 6px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.qe-fullscreen-preview__check:hover {\n  filter: brightness(0.95);\n}\n\n/* Answer-check result banner */\n.qe-preview-check {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 36px 12px 16px;\n  margin-bottom: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--qe-border);\n  background: var(--qe-bg-panel);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.qe-preview-check--success {\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.qe-preview-check--warn {\n  border-color: #f59e0b;\n  background: #fffbeb;\n}\n\n.qe-preview-check--info {\n  border-color: var(--qe-border);\n  background: var(--qe-bg-panel);\n}\n\n.qe-preview-check__summary {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n}\n\n.qe-preview-check__list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.qe-preview-check__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  border: 1px solid var(--qe-border);\n  background: #ffffff;\n}\n\n.qe-preview-check__item-label {\n  color: var(--qe-text-secondary);\n}\n\n.qe-preview-check__item-status {\n  font-weight: 600;\n}\n\n.qe-preview-check__item.is-correct {\n  border-color: #16a34a;\n}\n\n.qe-preview-check__item.is-correct .qe-preview-check__item-status {\n  color: #16a34a;\n}\n\n.qe-preview-check__item.is-wrong {\n  border-color: #dc2626;\n}\n\n.qe-preview-check__item.is-wrong .qe-preview-check__item-status {\n  color: #dc2626;\n}\n\n.qe-preview-check__item.is-empty {\n  border-color: var(--qe-border);\n}\n\n.qe-preview-check__item.is-empty .qe-preview-check__item-status {\n  color: var(--qe-text-muted);\n}\n\n.qe-preview-check__dismiss {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  line-height: 1;\n  color: var(--qe-text-muted);\n  cursor: pointer;\n}\n\n.qe-preview-check__dismiss:hover {\n  color: var(--qe-text-primary);\n}\n\n.qe-fullscreen-preview__canvas-wrapper {\n  flex: 1;\n  width: 100%;\n  height: auto;\n  min-height: 200px;\n  padding: 20px 0;\n}\n\n.qe-fullscreen-preview__canvas {\n  position: relative;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.qe-preview-only {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  background: var(--qe-bg-surface, #f1f5f9);\n}\n\n.qe-preview-only__canvas-wrapper {\n  width: 100%;\n  max-width: 960px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: var(--qe-shadow-lg, 0 10px 30px rgba(15, 23, 42, 0.08));\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.qe-preview-only__canvas {\n  position: relative;\n  margin: 0 auto;\n  background: white;\n  overflow: hidden;\n}\n\n.qe-preview-only__loader,\n.qe-preview-only__message {\n  font-size: 16px;\n  color: #111827;\n  background: white;\n  padding: 16px 24px;\n  border-radius: 12px;\n  box-shadow: var(--qe-shadow-md, 0 6px 20px rgba(15, 23, 42, 0.08));\n}\n\n.qe-preview-only__loader {\n  font-weight: 600;\n}\n\n.qe-panel__title {\n  padding: 18px 20px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--qe-text-muted);\n}\n\n.qe-panel__content {\n  padding: 0 20px 20px;\n  font-size: 14px;\n  color: var(--qe-text-secondary);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-panel__content--padded {\n  padding: 16px 20px 20px;\n  gap: 12px;\n}\n\n.qe-panel__content--scroll {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.qe-panel__section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.qe-panel__section + .qe-panel__section {\n  margin-top: 16px;\n}\n\n.qe-panel__subtitle {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--qe-text-muted);\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 6px;\n}\n\n.qe-properties-section__title--collapsible {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 14px 16px;\n  margin: 0;\n  background: none;\n  border: none;\n  width: 100%;\n  transition: color 0.2s ease;\n  user-select: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  pointer-events: auto;\n}\n\n.qe-properties-section__title--collapsible.qe-properties-section__title--open {\n  color: var(--qe-accent);\n}\n\n.qe-properties-section__title--collapsible:hover {\n  color: var(--qe-accent);\n}\n\n.qe-properties-section__icon {\n  transition: transform 0.2s ease, color 0.2s ease;\n  color: #6f7787;\n  flex-shrink: 0;\n  display: inline-block;\n}\n\n.qe-properties-section__icon--open {\n  transform: rotate(180deg);\n  color: var(--qe-accent);\n}\n\n.qe-properties-section .qe-form__label,\n.qe-properties-section .qe-inline-input__label {\n  user-select: none;\n}\n\n.qe-properties-section .qe-input[readonly] {\n  user-select: none;\n}\n\n.qe-chip-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-pill {\n  display: inline-block;\n  width: auto;\n  min-width: 100%;\n  padding: 10px 12px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n.qe-pill:hover {\n  background-color: var(--qe-accent-muted);\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-pill.qe-pill--active {\n  background-color: var(--qe-accent);\n  border-color: var(--qe-accent);\n  color: #ffffff;\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.2);\n}\n\n.qe-pill.qe-pill--active:hover {\n  background-color: var(--qe-accent-hover);\n  border-color: var(--qe-accent-hover);\n  color: #ffffff;\n}\n\n.qe-pill:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.qe-asset {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid rgba(217, 221, 231, 0.5);\n}\n\n.qe-asset:last-child {\n  border-bottom: none;\n}\n\n.qe-asset__thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: linear-gradient(\n    135deg,\n    rgba(37, 99, 235, 0.18),\n    rgba(137, 87, 229, 0.18)\n  );\n}\n\n.qe-asset__thumb--audio {\n  background: linear-gradient(\n    135deg,\n    rgba(22, 163, 74, 0.2),\n    rgba(37, 99, 235, 0.2)\n  );\n}\n\n.qe-asset__thumb--video {\n  background: linear-gradient(\n    135deg,\n    rgba(239, 170, 45, 0.2),\n    rgba(37, 99, 235, 0.2)\n  );\n}\n\n.qe-asset__thumb--svg {\n  background: linear-gradient(\n    135deg,\n    rgba(147, 51, 234, 0.2),\n    rgba(59, 130, 246, 0.2)\n  );\n}\n\n.qe-asset__thumb--vector {\n  background: linear-gradient(\n    135deg,\n    rgba(147, 51, 234, 0.2),\n    rgba(59, 130, 246, 0.2)\n  );\n}\n\n.qe-asset__name {\n  font-weight: 600;\n  color: var(--qe-text-primary);\n}\n\n.qe-asset__meta {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n}\n\n.qe-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 0;\n  overflow: visible;\n  flex: 1;\n  max-height: none;\n}\n\n.qe-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.qe-form__label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--qe-text-muted);\n}\n\n.qe-form__help {\n  font-size: 11px;\n  color: var(--qe-text-muted);\n}\n\n.qe-inline-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n}\n\n.qe-inline-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.qe-inline-input {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.qe-inline-input__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--qe-text-muted);\n}\n\n.qe-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--qe-border);\n  background-color: #ffffff;\n  font-size: 13px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.qe-input:focus {\n  outline: none;\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.qe-input--color {\n  padding: 4px;\n  height: 48px;\n  width: 80px;\n}\n\n.qe-input--textarea {\n  resize: vertical;\n  min-height: 90px;\n}\n\n.qe-chip-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.qe-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--qe-border);\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--qe-text-secondary);\n}\n\n.qe-chip--active {\n  background-color: rgba(37, 99, 235, 0.18);\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-chip__label {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.qe-chip__label:focus-visible {\n  outline: 2px solid var(--qe-accent);\n  outline-offset: 2px;\n  border-radius: 999px;\n}\n\n.qe-chip__remove {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.qe-chip__remove:hover {\n  opacity: 1;\n}\n\n.qe-multi-select {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n  width: 100%;\n}\n\n.qe-multi-select__input {\n  display: flex;\n  gap: 8px;\n}\n\n.qe-multi-select__popover {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.qe-multi-select__create {\n  margin-top: 6px;\n  margin-bottom: 6px;\n  padding: 6px 8px;\n  border: 1px dashed var(--qe-border);\n  border-radius: 6px;\n  background: #f8fafc;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--qe-accent);\n  text-align: left;\n  cursor: pointer;\n}\n\n.qe-multi-select__list {\n  width: 100%;\n  border: 1px solid var(--qe-border);\n  border-radius: 10px;\n  background-color: #ffffff;\n  padding: 6px;\n  max-height: 220px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.qe-multi-select__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n\n.qe-multi-select__row:hover {\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.qe-multi-select__row--active {\n  background: transparent;\n}\n\n.qe-multi-select__label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--qe-text-primary);\n  cursor: pointer;\n  flex: 1;\n}\n\n.qe-multi-select__checkbox {\n  width: 16px;\n  height: 16px;\n}\n\n.qe-multi-select__remove {\n  border: none;\n  background: transparent;\n  padding: 4px;\n  font: inherit;\n  color: var(--qe-text-muted);\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.qe-multi-select__remove:hover {\n  opacity: 1;\n}\n\n.qe-multi-select__empty {\n  padding: 8px;\n  font-size: 12px;\n  color: var(--qe-text-muted);\n}\n\n.qe-mapping-table {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-mapping-table__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px dashed rgba(31, 36, 48, 0.2);\n  background-color: rgba(31, 36, 48, 0.02);\n}\n\n.qe-mapping-table__cell {\n  font-size: 13px;\n  color: var(--qe-text-primary);\n}\n\n.qe-icon-link {\n  border: none;\n  background: none;\n  color: var(--qe-accent);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.qe-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--qe-text-secondary);\n}\n\n.qe-toggle input {\n  width: 16px;\n  height: 16px;\n}\n\n.qe-simple-list {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--qe-text-secondary);\n  font-size: 13px;\n}\n\n.qe-simple-list li {\n  margin-bottom: 4px;\n}\n\n.qe-layer-item {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 6px;\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background-color: #f8fafc;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n  cursor: grab;\n}\n\n.qe-layer-item:active {\n  cursor: grabbing;\n}\n\n.qe-layer-item--active {\n  background-color: var(--qe-accent-muted);\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.qe-layer-item--active .qe-layer-item__name {\n  color: var(--qe-accent);\n  font-weight: 600;\n}\n\n.qe-layer-item:focus {\n  outline: none;\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);\n}\n\n.qe-layer-item__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.qe-layer-item__name {\n  font-weight: 600;\n  color: var(--qe-text-secondary);\n}\n\n.qe-layer-item__meta {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n}\n\n.qe-layer-item__actions {\n  display: flex;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.qe-layer-item--dragging {\n  opacity: 0.9;\n}\n\n.qe-layer-item-drop-zone {\n  height: 8px;\n  position: relative;\n}\n\n.qe-layer-item-drop-zone:first-child {\n  margin-top: -4px;\n}\n\n.qe-layer-item-drop-zone:last-child {\n  margin-bottom: -4px;\n}\n\n.qe-layer-item-drop-zone:hover::after,\n.qe-layer-item-drop-zone[aria-dragging=\"true\"]::after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  height: 2px;\n  background-color: var(--qe-accent);\n  z-index: 1;\n}\n\n.qe-layer-item-placeholder {\n  height: 2px;\n  background-color: var(--qe-accent);\n  margin: 4px 12px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.qe-layer-item-placeholder--visible {\n  opacity: 1;\n}\n\n.qe-icon-button {\n  border: 1px solid var(--qe-border);\n  background-color: #ffffff;\n  color: var(--qe-text-secondary);\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 11px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.qe-icon-button:hover {\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n}\n\n.qe-layer-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 4px;\n}\n\n.qe-layer-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.qe-layer-list::-webkit-scrollbar-thumb {\n  background-color: rgba(31, 36, 48, 0.18);\n  border-radius: 4px;\n}\n\n.qe-layer-list::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.qe-panel__content--scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.qe-panel__content--scroll::-webkit-scrollbar-thumb {\n  background-color: rgba(31, 36, 48, 0.24);\n  border-radius: 4px;\n}\n\n.qe-panel__content--scroll::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n.qe-color-control {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n}\n\n.qe-color-control__label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--qe-text-muted);\n}\n\n.qe-color-control__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.qe-color-control__row .qe-input--color {\n  width: 48px;\n  height: 36px;\n  padding: 4px;\n  border: 1px solid var(--qe-border);\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.qe-color-control__row .qe-button--tiny {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n/* Standard color palette picker (öğe ayarlarındaki tüm renk kontrolleri) */\n.qe-standard-color-picker,\n.qe-standard-color-popover__swatch,\n.qe-standard-color-popover__transparent {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid var(--qe-border);\n  border-radius: 7px;\n  cursor: pointer;\n  box-sizing: border-box;\n  box-shadow: inset 0 0 0 2px #ffffff;\n}\n\n.qe-standard-color-picker {\n  flex: 0 0 auto;\n  background-clip: padding-box;\n}\n\n.qe-standard-color-picker:focus-visible,\n.qe-standard-color-popover__swatch:focus-visible,\n.qe-standard-color-popover__transparent:focus-visible {\n  outline: none;\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18), inset 0 0 0 2px #ffffff;\n}\n\n.qe-standard-color-popover {\n  position: fixed;\n  z-index: 10000;\n  padding: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.38);\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.18);\n}\n\n.qe-standard-color-popover__toolbar {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.qe-standard-color-popover__transparent {\n  width: 24px;\n  height: 24px;\n}\n\n.qe-standard-color-popover__icon {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--qe-border);\n  border-radius: 7px;\n  background: #ffffff;\n  color: var(--qe-text-secondary);\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.qe-standard-color-popover__icon--active,\n.qe-standard-color-popover__icon:hover {\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.qe-standard-color-popover__grid {\n  display: grid;\n  grid-template-columns: repeat(8, 24px);\n  gap: 5px;\n  justify-content: center;\n}\n\n.qe-standard-color-popover__swatch-wrap {\n  width: 24px;\n  height: 24px;\n}\n\n.qe-standard-color-popover__swatch--selected {\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.22), inset 0 0 0 2px #ffffff;\n}\n\n.qe-standard-color-popover__hex {\n  width: 100%;\n  min-height: 28px;\n  margin-top: 8px;\n  padding: 4px 8px;\n  border: 1px solid var(--qe-border);\n  border-radius: 7px;\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n    \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n/* Context Menu Styles */\n.qe-context-menu {\n  position: fixed;\n  z-index: 250;\n  background-color: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  min-width: 160px;\n  padding: 4px 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.qe-context-menu__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border: none;\n  background: none;\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: default;\n  width: 100%;\n  text-align: left;\n  transition: none;\n}\n\n.qe-context-menu__item:hover {\n  background-color: #2563eb;\n  color: #ffffff;\n}\n\n.qe-context-menu__item--danger:hover {\n  background-color: #dc2626;\n  color: #ffffff;\n}\n\n.qe-context-menu__separator {\n  height: 1px;\n  background-color: #e5e7eb;\n  margin: 4px 0;\n}\n\n/* Collapsible Sections */\n.qe-collapsible {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.qe-collapsible__toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n  text-align: left;\n  transition: background-color 0.15s ease;\n  user-select: none;\n}\n\n.qe-collapsible__toggle:hover {\n  background-color: #f8fafc;\n}\n\n.qe-collapsible__icon {\n  font-size: 10px;\n  color: var(--qe-text-muted);\n  transition: transform 0.2s ease;\n  font-family: monospace;\n}\n\n.qe-collapsible__content {\n  padding: 0 16px 16px 16px;\n}\n\n/* Choice Options Editor Panel Styling */\n.qe-properties-section__content .qe-choice-option {\n  display: block;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 10px;\n  transition: all 0.15s ease;\n}\n\n.qe-properties-section__content .qe-choice-option:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.qe-choice-option__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 10px;\n}\n\n.qe-choice-option__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qe-choice-option__remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.qe-choice-option__remove:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.qe-choice-option__remove svg {\n  display: block;\n}\n\n.qe-choice-option__advanced {\n  margin-top: 10px;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 10px;\n  overflow: visible;\n  height: auto;\n}\n\n.qe-choice-option__advanced[open] {\n  padding-bottom: 0;\n}\n\n.qe-choice-option__advanced-trigger {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--qe-text-muted);\n  padding: 4px 0;\n  transition: color 0.15s ease;\n  user-select: none;\n  list-style: none;\n}\n\n.qe-choice-option__advanced-trigger::-webkit-details-marker {\n  display: none;\n}\n\n.qe-choice-option__advanced-trigger:hover {\n  color: var(--qe-accent);\n}\n\n.qe-choice-option__advanced-trigger svg {\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.qe-choice-option__advanced[open] .qe-choice-option__advanced-trigger svg {\n  transform: rotate(180deg);\n}\n\n.qe-choice-option__advanced-content {\n  margin-top: 10px;\n  overflow: visible;\n  height: auto;\n}\n\n.qe-choice-option__advanced-content .qe-form__field {\n  margin-bottom: 16px;\n}\n\n/* Notification Animation */\n@keyframes slideIn {\n  from {\n    transform: translateX(-50%) translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(-50%) translateY(0);\n    opacity: 1;\n  }\n}\n\n.qe-choice-option__advanced-content .qe-form__field:last-child {\n  margin-bottom: 0;\n}\n\n/* Reset margin for form fields inside other containers with spacing */\n.qe-choice-option__advanced-content .qe-form__field,\n.qe-properties-section__content .qe-form__field {\n  margin-bottom: 16px;\n}\n\n.qe-choice-option__advanced-content .qe-form__field:last-child,\n.qe-properties-section__content .qe-form__field:last-child {\n  margin-bottom: 0;\n}\n\n/* Special handling for choice options section to allow expansion when open */\n.qe-properties-section--choice-options.qe-properties-section--active {\n  min-height: auto !important;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n/* Ensure choice options container can expand when open */\n.qe-properties-section--choice-options.qe-properties-section--active\n  .qe-properties-section__content-wrapper {\n  overflow: visible !important;\n  max-height: none !important;\n}\n\n.qe-properties-section--choice-options.qe-properties-section--active\n  .qe-properties-section__content {\n  overflow: visible !important;\n  min-height: auto !important;\n  height: auto !important;\n}\n\n/* Fallback for browsers without :has() support */\n.qe-properties-section:has(.qe-choice-option).qe-properties-section--active {\n  min-height: auto !important;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.qe-properties-section:has(.qe-choice-option).qe-properties-section--active\n  .qe-properties-section__content-wrapper {\n  overflow: visible !important;\n  max-height: none !important;\n}\n\n.qe-properties-section:has(.qe-choice-option).qe-properties-section--active\n  .qe-properties-section__content {\n  overflow: visible !important;\n  min-height: auto !important;\n  height: auto !important;\n}\n\n/* Checkbox Label Styling */\n.qe-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  color: var(--qe-text-primary);\n  transition: color 0.15s ease;\n}\n\n.qe-checkbox-label:hover {\n  color: var(--qe-text-secondary);\n}\n\n.qe-checkbox {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  border: 2px solid #cbd5e1;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.qe-checkbox:hover {\n  border-color: var(--qe-accent);\n}\n\n.qe-checkbox:checked {\n  background-color: var(--qe-accent);\n  border-color: var(--qe-accent);\n}\n\n/* Secondary Button */\n.qe-button--secondary {\n  background-color: #f8fafc;\n  border-color: #e2e8f0;\n  color: var(--qe-text-secondary);\n  font-weight: 500;\n}\n\n.qe-button--secondary:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n  color: var(--qe-text-primary);\n}\n\n/* Answer Key Styles */\n.qe-answer-key-section {\n  margin-bottom: 20px;\n  padding: 16px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.qe-answer-key-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.qe-answer-key-header strong {\n  font-size: 14px;\n  color: var(--qe-text-primary);\n}\n\n.qe-answer-key-type {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n  font-weight: 500;\n}\n\n.qe-answer-key-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-answer-key-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background-color: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.qe-answer-key-option:hover {\n  border-color: #cbd5e1;\n  background-color: #fafbfc;\n}\n\n.qe-answer-key-option--selected {\n  background-color: #e1e9ff;\n  border-color: var(--qe-accent);\n}\n\n.qe-answer-key-option--selected:hover {\n  background-color: #d4dff7;\n}\n\n.qe-answer-key-option input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.qe-answer-key-option-label {\n  flex: 1;\n  font-size: 14px;\n  color: var(--qe-text-primary);\n  font-weight: 500;\n}\n\n.qe-answer-key-option-value {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n  font-family: \"Courier New\", monospace;\n}\n\n/* Layer Drag and Drop Styles */\n.qe-layer-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 0;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: none;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #f8fafc;\n  position: relative;\n}\n\n.qe-layer-item:first-child {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.qe-layer-item:last-child {\n  border-bottom: none;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.qe-layer-item:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.qe-layer-item--active {\n  background-color: var(--qe-accent-muted);\n  border-color: var(--qe-accent);\n}\n\n.qe-layer-item--active .qe-layer-item__name {\n  color: var(--qe-accent);\n  font-weight: 600;\n}\n\n.qe-layer-item--dragging {\n  opacity: 0.6;\n  transform: scale(0.98);\n  cursor: grabbing;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 10;\n  position: relative;\n}\n\n.qe-layer-item__drag-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: var(--qe-text-muted);\n  cursor: grab;\n  border-radius: 3px;\n  transition: all 0.15s ease;\n}\n\n.qe-layer-item__drag-handle:hover {\n  background-color: #e5e7eb;\n  color: var(--qe-text-secondary);\n}\n\n.qe-layer-item:active .qe-layer-item__drag-handle {\n  cursor: grabbing;\n}\n\n.qe-layer-item__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.qe-layer-item__name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--qe-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.qe-layer-item__meta {\n  font-size: 11px;\n  color: var(--qe-text-muted);\n  margin-top: 2px;\n}\n\n.qe-layer-item__actions {\n  display: flex;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n.qe-layer-item:hover .qe-layer-item__actions {\n  opacity: 1;\n}\n\n/* Toast Notifications */\n[data-sonner-toast][data-type=\"success\"] {\n  background-color: var(--qe-success) !important;\n  border-color: var(--qe-success) !important;\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"success\"] [data-icon] {\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"success\"] [data-content] {\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"error\"] {\n  background-color: var(--qe-error) !important;\n  border-color: var(--qe-error) !important;\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"error\"] [data-icon] {\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"error\"] [data-content] {\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"warning\"] {\n  background-color: var(--qe-warning) !important;\n  border-color: var(--qe-warning) !important;\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"warning\"] [data-icon] {\n  color: white !important;\n}\n\n[data-sonner-toast][data-type=\"warning\"] [data-content] {\n  color: white !important;\n}\n\n/* Fade in animation for warning messages */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n/* Shortcuts Section */\n.qe-shortcuts-section {\n  padding: 12px;\n}\n\n.qe-shortcuts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.qe-shortcut-item {\n  padding: 12px;\n  background: var(--qe-bg-panel);\n  border: 1px solid var(--qe-border);\n  border-radius: 8px;\n  transition: all 0.15s ease;\n}\n\n.qe-shortcut-item:hover {\n  border-color: var(--qe-border-strong);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.qe-shortcut-item:hover .qe-shortcut-item__pin {\n  opacity: 1;\n}\n\n.qe-shortcut-item__content {\n  width: 100%;\n}\n\n.qe-shortcut-item__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.qe-shortcut-item__label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--qe-text-primary);\n  flex: 1;\n}\n\n.qe-shortcut-item__pin {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  opacity: 0.4;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.qe-shortcut-item__pin:hover {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.qe-shortcut-item__type {\n  font-size: 11px;\n  color: var(--qe-text-muted);\n}\n\n/* Modal Styles */\n.qe-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20000; /* En yüksek z-index - her zaman en üstte */\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.qe-modal-content {\n  background: var(--qe-bg-panel);\n  border-radius: var(--qe-radius-base);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.qe-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--qe-border);\n}\n\n.qe-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n}\n\n.qe-modal-close {\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: var(--qe-text-muted);\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.qe-modal-close:hover {\n  background-color: var(--qe-bg-muted);\n  color: var(--qe-text-primary);\n}\n\n.qe-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n.qe-modal-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 16px 24px;\n  border-top: 1px solid var(--qe-border);\n  background-color: var(--qe-bg-surface);\n}\n\n.qe-modal-footer .qe-button {\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  outline: none;\n}\n\n.qe-modal-footer .qe-button--primary {\n  background-color: var(--qe-accent);\n  color: white;\n}\n\n.qe-modal-footer .qe-button--primary:hover {\n  background-color: var(--qe-accent-hover);\n}\n\n.qe-modal-footer .qe-button--secondary {\n  background-color: transparent;\n  color: var(--qe-text-secondary);\n  border: 1px solid var(--qe-border);\n}\n\n.qe-modal-footer .qe-button--secondary:hover {\n  background-color: var(--qe-bg-muted);\n  border-color: var(--qe-border-strong);\n}\n\n/* Question Type Change Confirm Modal Styles */\n.qe-modal__content--warning {\n  width: 480px;\n  max-width: calc(100vw - 32px);\n}\n\n.qe-modal__content--warning .qe-modal__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--qe-border);\n}\n\n.qe-modal__header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(\n    135deg,\n    rgba(239, 170, 45, 0.15),\n    rgba(239, 170, 45, 0.25)\n  );\n  color: var(--qe-warning);\n  flex-shrink: 0;\n}\n\n.qe-modal__content--warning .qe-modal__header-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.qe-modal__content--warning .qe-modal__title {\n  margin: 0 0 4px 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--qe-text-primary);\n  line-height: 1.3;\n}\n\n.qe-modal__content--warning .qe-modal__subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--qe-text-muted);\n  font-weight: 500;\n}\n\n.qe-modal__content--warning .qe-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px 0;\n}\n\n.qe-modal__info-box {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: linear-gradient(\n    135deg,\n    rgba(37, 99, 235, 0.06),\n    rgba(37, 99, 235, 0.1)\n  );\n  border: 1px solid rgba(37, 99, 235, 0.2);\n  border-radius: 12px;\n}\n\n.qe-modal__info-icon {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--qe-accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.qe-modal__info-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.qe-modal__info-text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--qe-text-primary);\n}\n\n.qe-modal__highlight {\n  font-weight: 700;\n  color: var(--qe-accent);\n  font-size: 15px;\n}\n\n.qe-modal__change-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.qe-modal__change-text {\n  margin: 0;\n  font-size: 14px;\n  color: var(--qe-text-secondary);\n  font-weight: 500;\n}\n\n.qe-modal__type-change {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: var(--qe-bg-surface);\n  border-radius: 12px;\n  border: 1px solid var(--qe-border);\n}\n\n.qe-modal__type-badge {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: white;\n  border: 2px solid var(--qe-border);\n  transition: all 0.2s ease;\n}\n\n.qe-modal__type-badge--current {\n  border-color: rgba(111, 119, 135, 0.3);\n}\n\n.qe-modal__type-badge--new {\n  border-color: var(--qe-accent);\n  background: linear-gradient(\n    135deg,\n    rgba(37, 99, 235, 0.05),\n    rgba(37, 99, 235, 0.1)\n  );\n}\n\n.qe-modal__type-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--qe-text-muted);\n}\n\n.qe-modal__type-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--qe-text-primary);\n  line-height: 1.3;\n}\n\n.qe-modal__type-badge--new .qe-modal__type-name {\n  color: var(--qe-accent);\n}\n\n.qe-modal__type-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  color: var(--qe-text-muted);\n  flex-shrink: 0;\n}\n\n.qe-modal__warning-box {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: linear-gradient(\n    135deg,\n    rgba(239, 170, 45, 0.1),\n    rgba(239, 170, 45, 0.15)\n  );\n  border: 1px solid rgba(239, 170, 45, 0.3);\n  border-radius: 12px;\n}\n\n.qe-modal__warning-icon {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--qe-warning);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.qe-modal__warning-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.qe-modal__warning-title {\n  display: block;\n  margin: 0 0 6px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--qe-warning);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.qe-modal__warning-text {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--qe-text-primary);\n}\n\n.qe-modal__content--warning .qe-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid var(--qe-border);\n}\n\n.qe-button--danger {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.25);\n}\n\n.qe-button--danger:hover {\n  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.35);\n  transform: translateY(-1px);\n}\n\n.qe-button--danger:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.25);\n}\n\n/* Save Success Modal Styles - Modern Card Design */\n.qe-modal__content--success {\n  width: 520px;\n  max-width: calc(100vw - 32px);\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: none;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.qe-modal__success-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 32px 32px;\n}\n\n/* Success Icon Animation */\n.qe-modal__success-icon-wrapper {\n  position: relative;\n  margin-bottom: 24px;\n  animation: successBounce 0.6s ease-out;\n}\n\n@keyframes successBounce {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.qe-modal__success-icon-large {\n  color: #22c55e;\n  display: block;\n}\n\n.qe-modal__success-check {\n  animation: checkDraw 0.4s ease-out 0.3s both;\n}\n\n@keyframes checkDraw {\n  0% {\n    stroke-dasharray: 50;\n    stroke-dashoffset: 50;\n  }\n  100% {\n    stroke-dasharray: 50;\n    stroke-dashoffset: 0;\n  }\n}\n\n/* Success Heading */\n.qe-modal__success-heading {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.qe-modal__success-title {\n  margin: 0 0 12px 0;\n  font-size: 28px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.qe-modal__success-message {\n  margin: 0;\n  font-size: 16px;\n  color: var(--qe-text-secondary, #64748b);\n  font-weight: 500;\n}\n\n/* Action Cards */\n.qe-modal__action-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.qe-modal__action-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  background: #ffffff;\n  border: 2px solid transparent;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-align: left;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.qe-modal__action-card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, transparent 0%, rgba(255, 255, 255, 0.5) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.qe-modal__action-card:hover::before {\n  opacity: 1;\n}\n\n.qe-modal__action-card--continue {\n  border-color: #e2e8f0;\n  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);\n}\n\n.qe-modal__action-card--continue:hover {\n  border-color: #22c55e;\n  box-shadow: 0 8px 25px -5px rgba(34, 197, 94, 0.3);\n  transform: translateY(-2px);\n}\n\n.qe-modal__action-card--redirect {\n  border-color: #e2e8f0;\n  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);\n}\n\n.qe-modal__action-card--redirect:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 8px 25px -5px rgba(59, 130, 246, 0.3);\n  transform: translateY(-2px);\n}\n\n.qe-modal__action-card:active {\n  transform: translateY(0);\n}\n\n.qe-modal__action-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.qe-modal__action-card--continue .qe-modal__action-card-icon {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  color: #ffffff;\n}\n\n.qe-modal__action-card--continue:hover .qe-modal__action-card-icon {\n  transform: scale(1.1) rotate(-5deg);\n}\n\n.qe-modal__action-card--redirect .qe-modal__action-card-icon {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: #ffffff;\n}\n\n.qe-modal__action-card--redirect:hover .qe-modal__action-card-icon {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.qe-modal__action-card-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.qe-modal__action-card-title {\n  margin: 0 0 4px 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--qe-text-primary, #1e293b);\n  transition: color 0.3s ease;\n}\n\n.qe-modal__action-card--continue:hover .qe-modal__action-card-title {\n  color: #16a34a;\n}\n\n.qe-modal__action-card--redirect:hover .qe-modal__action-card-title {\n  color: #2563eb;\n}\n\n.qe-modal__action-card-desc {\n  margin: 0;\n  font-size: 14px;\n  color: var(--qe-text-muted, #94a3b8);\n  font-weight: 500;\n}\n\n.qe-modal__action-card-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  opacity: 0;\n  transform: translateX(-8px);\n  transition: all 0.3s ease;\n}\n\n.qe-modal__action-card--continue .qe-modal__action-card-arrow {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.qe-modal__action-card--redirect .qe-modal__action-card-arrow {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.qe-modal__action-card:hover .qe-modal__action-card-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* Responsive */\n@media (max-width: 576px) {\n  .qe-modal__content--success {\n    width: 100%;\n    max-width: calc(100vw - 16px);\n    border-radius: 16px;\n  }\n\n  .qe-modal__success-container {\n    padding: 32px 24px 24px;\n  }\n\n  .qe-modal__success-title {\n    font-size: 24px;\n  }\n\n  .qe-modal__success-message {\n    font-size: 15px;\n  }\n\n  .qe-modal__action-card {\n    padding: 16px;\n  }\n\n  .qe-modal__action-card-icon {\n    width: 48px;\n    height: 48px;\n  }\n\n  .qe-modal__action-card-title {\n    font-size: 16px;\n  }\n\n  .qe-modal__action-card-desc {\n    font-size: 13px;\n  }\n}\n\n/* Media Library Modal Styles */\n.qe-modal__content--media-library {\n  width: 800px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 64px);\n}\n\n.qe-media-library__search {\n  margin-bottom: 20px;\n}\n\n.qe-media-library__loading,\n.qe-media-library__error,\n.qe-media-library__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--qe-text-muted);\n  font-size: 14px;\n}\n\n.qe-media-library__error {\n  color: var(--qe-error);\n}\n\n.qe-media-library__groups {\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.qe-media-library__group {\n  margin-bottom: 32px;\n}\n\n.qe-media-library__group:last-child {\n  margin-bottom: 0;\n}\n\n.qe-media-library__group-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--qe-text);\n  margin: 0 0 12px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--qe-border);\n}\n\n.qe-media-library__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 16px;\n  padding: 4px;\n}\n\n.qe-media-library__item {\n  position: relative;\n  border: 2px solid var(--qe-border);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.qe-media-library__item:hover {\n  border-color: var(--qe-accent);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  transform: translateY(-2px);\n}\n\n.qe-media-library__item--selected {\n  border-color: var(--qe-accent);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.qe-media-library__item-image {\n  width: 100%;\n  aspect-ratio: 1;\n  background: var(--qe-bg-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.qe-media-library__item-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.qe-media-library__item-name {\n  padding: 8px 12px 4px;\n  font-size: 12px;\n  color: var(--qe-text-secondary);\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-top: 1px solid var(--qe-border);\n  background: var(--qe-bg-surface);\n  font-weight: 500;\n}\n\n.qe-media-library__item-size {\n  padding: 0 12px 8px;\n  font-size: 11px;\n  color: var(--qe-text-muted);\n  text-align: center;\n  background: var(--qe-bg-surface);\n}\n\n.qe-template-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 12px 8px;\n  background: var(--qe-bg-surface);\n  justify-content: center;\n}\n\n.qe-template-tag {\n  font-size: 10px;\n  color: var(--qe-text-secondary);\n  background: #e8edf7;\n  border-radius: 999px;\n  padding: 2px 8px;\n  line-height: 1.2;\n}\n\n.qe-template-tag--more {\n  background: transparent;\n  border: 1px dashed var(--qe-border);\n  color: var(--qe-text-muted);\n}\n\n.qe-media-library__item-check {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  background: var(--qe-accent);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n}\n\n.qe-media-library__groups::-webkit-scrollbar {\n  width: 8px;\n}\n\n.qe-media-library__groups::-webkit-scrollbar-thumb {\n  background-color: rgba(31, 36, 48, 0.24);\n  border-radius: 4px;\n}\n\n.qe-media-library__groups::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n/* Media Library Button */\n.qe-media-library-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: 1px solid var(--qe-border);\n  border-radius: 8px;\n  background: white;\n  color: var(--qe-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.qe-media-library-button:hover:not(:disabled) {\n  border-color: var(--qe-accent);\n  background: var(--qe-accent-muted);\n  color: var(--qe-accent);\n}\n\n.qe-media-library-button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.qe-media-library-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: var(--qe-bg-surface);\n  color: var(--qe-text-muted);\n  border-color: var(--qe-border);\n}\n\n.qe-media-library-button:disabled:hover {\n  border-color: var(--qe-border);\n  background: var(--qe-bg-surface);\n  color: var(--qe-text-muted);\n}\n\n.qe-media-library-button__icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.qe-media-library-button--has-value {\n  border-color: var(--qe-accent);\n  background: var(--qe-accent-muted);\n  color: var(--qe-accent);\n}\n\n.qe-media-library-button--has-value:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  border-color: var(--qe-border);\n  background: var(--qe-bg-surface);\n  color: var(--qe-text-muted);\n}\n\n/* Redirect Overlay */\n.qe-redirect-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(31, 36, 48, 0.85);\n  backdrop-filter: blur(8px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: qe-redirect-overlay-fade-in 0.3s ease-out;\n}\n\n@keyframes qe-redirect-overlay-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.qe-redirect-overlay__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  color: #ffffff;\n}\n\n.qe-redirect-overlay__spinner {\n  width: 64px;\n  height: 64px;\n  position: relative;\n}\n\n.qe-redirect-overlay__spinner-circle {\n  width: 100%;\n  height: 100%;\n  border: 4px solid rgba(255, 255, 255, 0.2);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: qe-redirect-spinner-rotate 1s linear infinite;\n}\n\n@keyframes qe-redirect-spinner-rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.qe-redirect-overlay__message {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  animation: qe-redirect-message-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes qe-redirect-message-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* Saving Overlay */\n.qe-saving-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(31, 36, 48, 0.85);\n  backdrop-filter: blur(8px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: qe-saving-overlay-fade-in 0.3s ease-out;\n}\n\n@keyframes qe-saving-overlay-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.qe-saving-overlay__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  color: #ffffff;\n}\n\n.qe-saving-overlay__spinner {\n  width: 64px;\n  height: 64px;\n  position: relative;\n}\n\n.qe-saving-overlay__spinner-svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.qe-saving-overlay__spinner-circle {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 4;\n  stroke-dasharray: 126; /* 2 * PI * r(20) ≈ 125.66 */\n  stroke-dashoffset: 126;\n  animation: qe-saving-spinner-dash 1.5s ease-in-out infinite;\n  transform-origin: center;\n}\n\n@keyframes qe-saving-spinner-dash {\n  0% {\n    stroke-dasharray: 1, 126;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 66, 126;\n    stroke-dashoffset: -32;\n  }\n  100% {\n    stroke-dasharray: 66, 126;\n    stroke-dashoffset: -126;\n  }\n}\n\n.qe-saving-overlay__message {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  animation: qe-saving-message-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes qe-saving-message-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.qe-media-library-button--has-value:hover {\n  background: rgba(37, 99, 235, 0.15);\n}\n\n/* Sound Library Modal Styles */\n.qe-modal__content--sound-library {\n  width: 700px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-modal__content--sound-library .qe-modal__body {\n  padding: 20px 24px;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-modal__content--sound-library .qe-modal__footer {\n  padding: 16px 24px;\n  border-top: 1px solid var(--qe-border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.qe-sound-library__loading,\n.qe-sound-library__error,\n.qe-sound-library__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--qe-text-muted);\n  font-size: 14px;\n}\n\n.qe-sound-library__error {\n  color: var(--qe-error);\n}\n\n/* Breadcrumb Navigation */\n.qe-file-browser__breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  background: linear-gradient(to right, #f8f9fa, #ffffff);\n  border: 1px solid var(--qe-border);\n  border-radius: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.qe-file-browser__breadcrumb-item {\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid var(--qe-border);\n  color: var(--qe-text);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.qe-file-browser__breadcrumb-item:hover {\n  background: var(--qe-accent);\n  color: white;\n  border-color: var(--qe-accent);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n.qe-file-browser__breadcrumb-separator {\n  color: var(--qe-text-muted);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* File Browser Content */\n.qe-file-browser__content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid var(--qe-border);\n  border-radius: 10px;\n  background: #fafbfc;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Media library grid inside file browser content */\n.qe-file-browser__content .qe-media-library__grid {\n  padding: 0;\n  margin-top: 8px;\n}\n\n.qe-file-browser__content::-webkit-scrollbar {\n  width: 10px;\n}\n\n.qe-file-browser__content::-webkit-scrollbar-thumb {\n  background-color: rgba(31, 36, 48, 0.2);\n  border-radius: 5px;\n  border: 2px solid #fafbfc;\n}\n\n.qe-file-browser__content::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(31, 36, 48, 0.3);\n}\n\n.qe-file-browser__content::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.qe-file-browser__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--qe-text-muted);\n  font-size: 14px;\n}\n\n.qe-file-browser__item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  border: 1px solid transparent;\n  margin-bottom: 6px;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.qe-file-browser__item--folder {\n  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);\n}\n\n.qe-file-browser__item--folder:hover {\n  /* No hover effects */\n}\n\n.qe-file-browser__item--file {\n  color: var(--qe-text);\n  background: white;\n}\n\n.qe-file-browser__item--file:hover {\n  /* No background color change */\n}\n\n.qe-file-browser__item--selected {\n  background: rgba(37, 99, 235, 0.1);\n  border-color: var(--qe-accent);\n  color: var(--qe-accent);\n  font-weight: 500;\n}\n\n.qe-file-browser__icon {\n  font-size: 22px;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.qe-file-browser__name {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n}\n\n.qe-file-browser__count {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.qe-file-browser__size {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n  transition: color 0.2s ease;\n}\n\n.qe-file-browser__arrow {\n  color: var(--qe-text-muted);\n  font-size: 16px;\n  transition: all 0.2s ease;\n}\n\n.qe-file-browser__check {\n  color: var(--qe-accent);\n  font-weight: bold;\n  font-size: 18px;\n}\n\n/* Play Button */\n.qe-file-browser__play-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: var(--qe-accent);\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.qe-file-browser__play-btn:hover {\n  background: #4338ca;\n  transform: scale(1.05);\n}\n\n.qe-file-browser__play-btn:active {\n  transform: scale(0.95);\n}\n\n.qe-file-browser__item--playing {\n  border-color: var(--qe-accent);\n  background: rgba(37, 99, 235, 0.05);\n}\n\n.qe-file-browser__item--playing .qe-file-browser__play-btn {\n  background: #ef4444;\n}\n\n.qe-file-browser__item--playing .qe-file-browser__play-btn:hover {\n  background: #dc2626;\n}\n\n/* Video Library Modal Styles */\n.qe-modal__content--video-library {\n  width: 700px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-modal__content--video-library .qe-modal__body {\n  padding: 20px 24px;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.qe-modal__content--video-library .qe-modal__footer {\n  padding: 16px 24px;\n  border-top: 1px solid var(--qe-border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.qe-video-library__loading,\n.qe-video-library__error,\n.qe-video-library__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--qe-text-muted);\n  font-size: 14px;\n}\n\n.qe-video-library__error {\n  color: var(--qe-error);\n}\n\n/* Video Library Grid Layout */\n.qe-video-library__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  padding: 16px 0;\n}\n\n.qe-video-library__card {\n  border: 2px solid var(--qe-border);\n  border-radius: 12px;\n  overflow: hidden;\n  background: white;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.qe-video-library__card:hover {\n  border-color: #6366f1;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15);\n  transform: translateY(-2px);\n}\n\n.qe-video-library__card--selected {\n  border-color: #22c55e;\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);\n}\n\n/* Video Thumbnail */\n.qe-video-library__thumbnail {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #1e293b;\n  overflow: hidden;\n}\n\n.qe-video-library__preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.qe-video-library__play-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.4);\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.qe-video-library__play-overlay svg {\n  color: white;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n.qe-video-library__play-overlay--hidden {\n  opacity: 0;\n}\n\n.qe-video-library__selected-indicator {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  background: #22c55e;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.qe-video-library__selected-indicator svg {\n  color: white;\n  width: 14px;\n  height: 14px;\n}\n\n/* Video Info */\n.qe-video-library__info {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.qe-video-library__name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--qe-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.qe-video-library__name:hover {\n  color: #6366f1;\n}\n\n.qe-video-library__size {\n  font-size: 12px;\n  color: var(--qe-text-muted);\n}\n\n.qe-video-library__select-btn {\n  margin-top: 4px;\n  padding: 6px 12px;\n  border: 1px solid var(--qe-border);\n  border-radius: 6px;\n  background: white;\n  color: var(--qe-text);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.qe-video-library__select-btn:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.qe-video-library__select-btn--selected {\n  background: #22c55e;\n  border-color: #22c55e;\n  color: white;\n}\n\n.qe-video-library__select-btn--selected:hover {\n  background: #16a34a;\n  border-color: #16a34a;\n}\n\n/* Image Preview Modal Styles */\n.qe-modal__content--image-preview {\n  width: 90vw;\n  max-width: 1200px;\n  max-height: 90vh;\n}\n\n.qe-modal__body--image-preview {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  max-height: calc(90vh - 140px);\n  overflow: hidden;\n}\n\n.qe-image-preview__container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--qe-bg-surface);\n  padding: 20px;\n  min-height: 400px;\n}\n\n.qe-image-preview__image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
